// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2236px%22%20height%3D%2212px%22%3E%3Cpath%20fill%3D%22rgba%2817,%2017,%2017,%200.9%29%22%20transform%3D%22rotate%280%29%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2236px%22%20height%3D%2212px%22%3E%3Cpath%20fill%3D%22rgba%2817,%2017,%2017,%200.9%29%22%20transform%3D%22rotate%28180%2018%206%29%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2212px%22%20height%3D%2236px%22%3E%3Cpath%20fill%3D%22rgba%2817,%2017,%2017,%200.9%29%22%20transform%3D%22rotate%28-90%2018%2018%29%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2212px%22%20height%3D%2236px%22%3E%3Cpath%20fill%3D%22rgba%2817,%2017,%2017,%200.9%29%22%20transform%3D%22rotate%2890%206%206%29%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2735%27 height=%2739%27 viewBox=%270 0 35 39%27%3E%3Cpath d=%27M1.708 38.66c1.709 0 3.417-3.417 6.834-3.417 3.416 0 5.125 3.417 8.61 3.417 3.348 0 5.056-3.417 8.473-3.417 4.305 0 5.125 3.417 6.833 3.417.889 0 1.709-.889 1.709-1.709v-19.68C34.167-5.757 0-5.757 0 17.271v19.68c0 .82.888 1.709 1.708 1.709zm8.542-17.084a3.383 3.383 0 01-3.417-3.416 3.383 3.383 0 013.417-3.417 3.383 3.383 0 013.417 3.417 3.383 3.383 0 01-3.417 3.416zm13.667 0A3.383 3.383 0 0120.5 18.16a3.383 3.383 0 013.417-3.417 3.383 3.383 0 013.416 3.417 3.383 3.383 0 01-3.416 3.416z%27 fill=%27%2523000%27 fill-rule=%27nonzero%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3Csvg width=%2748%27 height=%2748%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M24 1v1C11.85 2 2 11.85 2 24s9.85 22 22 22 22-9.85 22-22S36.15 2 24 2V1zm0 0V0c13.254 0 24 10.746 24 24S37.254 48 24 48 0 37.254 0 24 10.746 0 24 0v1zm7.707 19.293a.999.999 0 1 1-1.414 1.414L25 16.414V34a1 1 0 1 1-2 0V16.414l-5.293 5.293a.999.999 0 1 1-1.414-1.414l7-7a.999.999 0 0 1 1.414 0l7 7z%27 fill=%27%231269CF%27 fill-rule=%27nonzero%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3Csvg width=%2748%27 height=%2748%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M24 1v1C11.85 2 2 11.85 2 24s9.85 22 22 22 22-9.85 22-22S36.15 2 24 2V1zm0 0V0c13.254 0 24 10.746 24 24S37.254 48 24 48 0 37.254 0 24 10.746 0 24 0v1zm7.707 19.293a.999.999 0 1 1-1.414 1.414L25 16.414V34a1 1 0 1 1-2 0V16.414l-5.293 5.293a.999.999 0 1 1-1.414-1.414l7-7a.999.999 0 0 1 1.414 0l7 7z%27 fill=%27%2302BAF2%27 fill-rule=%27nonzero%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.uppy-Informer {
  position: absolute;
  right: 0;
  bottom: 60px;
  left: 0;
  z-index: 1005;
  text-align: center;
}
.uppy-Informer span > div {
  margin-bottom: 6px;
}

.uppy-Informer-animated {
  z-index: -1000;
  transform: translateY(350%);
  opacity: 0;
  transition: all 300ms ease-in;
}

.uppy-Informer p {
  display: inline-block;
  max-width: 90%;
  margin: 0;
  padding: 0;
  padding: 6px 15px;
  color: #fff;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.4;
  background-color: #757575;
  border-radius: 18px;
}
.uppy-size--md .uppy-Informer p {
  max-width: 500px;
  padding: 10px 20px;
  font-size: 14px;
  line-height: 1.3;
}
[data-uppy-theme=dark] .uppy-Informer p {
  background-color: #333;
}

[dir="ltr"] .uppy-Informer p span{
  left: 3px;
}

[dir="rtl"] .uppy-Informer p span{
  right: 3px;
}

[dir="ltr"] .uppy-Informer p span{
  margin-left: -1px;
}

[dir="rtl"] .uppy-Informer p span{
  margin-right: -1px;
}

.uppy-Informer p span {
  position: relative;
  top: -1px;
  display: inline-block;
  width: 13px;
  height: 13px;
  color: #525252;
  font-size: 10px;
  line-height: 12px;
  vertical-align: middle;
  background-color: #fff;
  border-radius: 50%;
}

.uppy-Informer p span:hover {
  cursor: help;
}

.uppy-Informer p span::after {
  line-height: 1.3;
  word-wrap: break-word;
}

/* -------------------------------------------------------------------
  Microtip

  Modern, lightweight css-only tooltips
  Just 1kb minified and gzipped

  @author Ghosh
  @package Microtip

----------------------------------------------------------------------
  1. Base Styles
  2. Direction Modifiers
  3. Position Modifiers
-------------------------------------------------------------------- */
/* ------------------------------------------------
  [1] Base Styles
------------------------------------------------- */
.uppy-Root [aria-label][role~=tooltip] {
  position: relative;
}

.uppy-Root [aria-label][role~=tooltip]::before,
.uppy-Root [aria-label][role~=tooltip]::after {
  position: absolute;
  z-index: 10;
  box-sizing: border-box;
  transform: translate3d(0, 0, 0);
  transform-origin: top;
  backface-visibility: hidden;
  opacity: 0;
  transition: all 0.18s ease-in-out 0s;
  transition: all var(--microtip-transition-duration, 0.18s) var(--microtip-transition-easing, ease-in-out) var(--microtip-transition-delay, 0s);
  pointer-events: none;
  will-change: transform;
}

.uppy-Root [aria-label][role~=tooltip]::before {
  background-size: 100% auto !important;
  content: "";
}

.uppy-Root [aria-label][role~=tooltip]::after {
  box-sizing: content-box;
  padding: 0.5em 1em;
  color: #fff;
  font-weight: normal;
  font-weight: var(--microtip-font-weight, normal);
  font-size: 13px;
  font-size: var(--microtip-font-size, 13px);
  white-space: nowrap;
  text-transform: none;
  text-transform: var(--microtip-text-transform, none);
  background: rgba(17, 17, 17, 0.9);
  border-radius: 4px;
  content: attr(aria-label);
}

.uppy-Root [aria-label][role~=tooltip]:hover::before,
.uppy-Root [aria-label][role~=tooltip]:hover::after,
.uppy-Root [aria-label][role~=tooltip]:focus::before,
.uppy-Root [aria-label][role~=tooltip]:focus::after {
  opacity: 1;
  pointer-events: auto;
}

/* ------------------------------------------------
  [2] Position Modifiers
------------------------------------------------- */
.uppy-Root [role~=tooltip][data-microtip-position|=top]::before {
  bottom: 100%;
  left: 50%;
  width: 18px;
  height: 6px;
  margin-bottom: 5px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  transform: translate3d(-50%, 0, 0);
}

.uppy-Root [role~=tooltip][data-microtip-position|=top]::after {
  bottom: 100%;
  left: 50%;
  margin-bottom: 11px;
  transform: translate3d(-50%, 0, 0);
}

.uppy-Root [role~=tooltip][data-microtip-position|=top]:hover::before {
  transform: translate3d(-50%, -5px, 0);
}

.uppy-Root [role~=tooltip][data-microtip-position=top]:hover::after {
  transform: translate3d(-50%, -5px, 0);
}

/* ------------------------------------------------
  [2.1] Top Left
------------------------------------------------- */
.uppy-Root [role~=tooltip][data-microtip-position=top-left]::after {
  bottom: 100%;
  transform: translate3d(calc(-100% + 16px), 0, 0);
}

.uppy-Root [role~=tooltip][data-microtip-position=top-left]:hover::after {
  transform: translate3d(calc(-100% + 16px), -5px, 0);
}

/* ------------------------------------------------
  [2.2] Top Right
------------------------------------------------- */
.uppy-Root [role~=tooltip][data-microtip-position=top-right]::after {
  bottom: 100%;
  transform: translate3d(calc(0% - 16px), 0, 0);
}

.uppy-Root [role~=tooltip][data-microtip-position=top-right]:hover::after {
  transform: translate3d(calc(0% - 16px), -5px, 0);
}

/* ------------------------------------------------
  [2.3] Bottom
------------------------------------------------- */
.uppy-Root [role~=tooltip][data-microtip-position|=bottom]::before {
  top: 100%;
  bottom: auto;
  left: 50%;
  width: 18px;
  height: 6px;
  margin-top: 5px;
  margin-bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
  transform: translate3d(-50%, -10px, 0);
}

.uppy-Root [role~=tooltip][data-microtip-position|=bottom]::after {
  top: 100%;
  left: 50%;
  margin-top: 11px;
  transform: translate3d(-50%, -10px, 0);
}

.uppy-Root [role~=tooltip][data-microtip-position|=bottom]:hover::before {
  transform: translate3d(-50%, 0, 0);
}

.uppy-Root [role~=tooltip][data-microtip-position=bottom]:hover::after {
  transform: translate3d(-50%, 0, 0);
}

/* ------------------------------------------------
  [2.4] Bottom Left
------------------------------------------------- */
.uppy-Root [role~=tooltip][data-microtip-position=bottom-left]::after {
  top: 100%;
  transform: translate3d(calc(-100% + 16px), -10px, 0);
}

.uppy-Root [role~=tooltip][data-microtip-position=bottom-left]:hover::after {
  transform: translate3d(calc(-100% + 16px), 0, 0);
}

/* ------------------------------------------------
  [2.5] Bottom Right
------------------------------------------------- */
.uppy-Root [role~=tooltip][data-microtip-position=bottom-right]::after {
  top: 100%;
  transform: translate3d(calc(0% - 16px), -10px, 0);
}

.uppy-Root [role~=tooltip][data-microtip-position=bottom-right]:hover::after {
  transform: translate3d(calc(0% - 16px), 0, 0);
}

/* ------------------------------------------------
  [2.6] Left
------------------------------------------------- */
.uppy-Root [role~=tooltip][data-microtip-position=left]::before,
.uppy-Root [role~=tooltip][data-microtip-position=left]::after {
  top: 50%;
  right: 100%;
  bottom: auto;
  left: auto;
  transform: translate3d(10px, -50%, 0);
}

.uppy-Root [role~=tooltip][data-microtip-position=left]::before {
  width: 6px;
  height: 18px;
  margin-right: 5px;
  margin-bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat;
}

.uppy-Root [role~=tooltip][data-microtip-position=left]::after {
  margin-right: 11px;
}

.uppy-Root [role~=tooltip][data-microtip-position=left]:hover::before,
.uppy-Root [role~=tooltip][data-microtip-position=left]:hover::after {
  transform: translate3d(0, -50%, 0);
}

/* ------------------------------------------------
  [2.7] Right
------------------------------------------------- */
.uppy-Root [role~=tooltip][data-microtip-position=right]::before,
.uppy-Root [role~=tooltip][data-microtip-position=right]::after {
  top: 50%;
  bottom: auto;
  left: 100%;
  transform: translate3d(-10px, -50%, 0);
}

.uppy-Root [role~=tooltip][data-microtip-position=right]::before {
  width: 6px;
  height: 18px;
  margin-bottom: 0;
  margin-left: 5px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat;
}

.uppy-Root [role~=tooltip][data-microtip-position=right]::after {
  margin-left: 11px;
}

.uppy-Root [role~=tooltip][data-microtip-position=right]:hover::before,
.uppy-Root [role~=tooltip][data-microtip-position=right]:hover::after {
  transform: translate3d(0, -50%, 0);
}

/* ------------------------------------------------
  [3] Size
------------------------------------------------- */
.uppy-Root [role~=tooltip][data-microtip-size=small]::after {
  width: 80px;
  white-space: normal;
  white-space: initial;
}

.uppy-Root [role~=tooltip][data-microtip-size=medium]::after {
  width: 150px;
  white-space: normal;
  white-space: initial;
}

.uppy-Root [role~=tooltip][data-microtip-size=large]::after {
  width: 260px;
  white-space: normal;
  white-space: initial;
}

.uppy-StatusBar {
  position: relative;
  z-index: 1001;
  display: flex;
  height: 46px;
  color: #fff;
  font-weight: 400;
  font-size: 12px;
  line-height: 40px;
  background-color: #fff;
  transition: height 0.2s;
}
[data-uppy-theme=dark] .uppy-StatusBar {
  background-color: #1f1f1f;
}

.uppy-StatusBar::before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #eaeaea;
  content: "";
}
[data-uppy-theme=dark] .uppy-StatusBar::before {
  background-color: #757575;
}

.uppy-StatusBar[aria-hidden=true] {
  height: 0;
  overflow-y: hidden;
}

.uppy-StatusBar.is-complete .uppy-StatusBar-progress {
  background-color: #1bb240;
}

.uppy-StatusBar.is-error .uppy-StatusBar-progress {
  background-color: #e32437;
}

.uppy-StatusBar.is-complete .uppy-StatusBar-statusIndicator {
  color: #1bb240;
}

.uppy-StatusBar.is-error .uppy-StatusBar-statusIndicator {
  color: #e32437;
}

.uppy-StatusBar:not([aria-hidden=true]).is-waiting {
  height: 65px;
  background-color: #fff;
  border-top: 1px solid #eaeaea;
}
[data-uppy-theme=dark] .uppy-StatusBar:not([aria-hidden=true]).is-waiting {
  background-color: #1f1f1f;
  border-top: 1px solid #333;
}

.uppy-StatusBar-progress {
  position: absolute;
  z-index: 1001;
  height: 2px;
  background-color: #1269cf;
  transition: background-color, width 0.3s ease-out;
}
.uppy-StatusBar-progress.is-indeterminate {
  background-image: linear-gradient(45deg, rgba(0, 0, 0, 0.3) 25%, transparent 25%, transparent 50%, rgba(0, 0, 0, 0.3) 50%, rgba(0, 0, 0, 0.3) 75%, transparent 75%, transparent);
  background-size: 64px 64px;
  animation: uppy-StatusBar-ProgressStripes 1s linear infinite;
}

@keyframes uppy-StatusBar-ProgressStripes {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 64px 0;
  }
}
.uppy-StatusBar.is-preprocessing .uppy-StatusBar-progress,
.uppy-StatusBar.is-postprocessing .uppy-StatusBar-progress {
  background-color: #f6a623;
}

.uppy-StatusBar.is-waiting .uppy-StatusBar-progress {
  display: none;
}

[dir="ltr"] .uppy-StatusBar-content{
  padding-left: 10px;
}

[dir="rtl"] .uppy-StatusBar-content{
  padding-right: 10px;
}

.uppy-StatusBar-content {
  position: relative;
  z-index: 1002;
  display: flex;
  align-items: center;
  height: 100%;
  color: #333;
  white-space: nowrap;
  text-overflow: ellipsis;
}
[dir="ltr"] .uppy-size--md .uppy-StatusBar-content{
  padding-left: 15px;
}
[dir="rtl"] .uppy-size--md .uppy-StatusBar-content{
  padding-right: 15px;
}
[data-uppy-theme=dark] .uppy-StatusBar-content {
  color: #eaeaea;
}

[dir="ltr"] .uppy-StatusBar-status{
  padding-right: 0.3em;
}

[dir="rtl"] .uppy-StatusBar-status{
  padding-left: 0.3em;
}

.uppy-StatusBar-status {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: normal;
  line-height: 1.4;
}

.uppy-StatusBar-statusPrimary {
  font-weight: 500;
  line-height: 1;
  display: flex;
}
.uppy-StatusBar-statusPrimary button.uppy-StatusBar-details {
  margin-left: 5px;
}
[data-uppy-theme=dark] .uppy-StatusBar-statusPrimary {
  color: #eaeaea;
}

.uppy-StatusBar-statusSecondary {
  display: inline-block;
  margin-top: 1px;
  color: #757575;
  font-size: 11px;
  line-height: 1.2;
  white-space: nowrap;
}
[data-uppy-theme=dark] .uppy-StatusBar-statusSecondary {
  color: #bbb;
}

[dir="ltr"] .uppy-StatusBar-statusSecondaryHint{
  margin-right: 5px;
}

[dir="rtl"] .uppy-StatusBar-statusSecondaryHint{
  margin-left: 5px;
}

.uppy-StatusBar-statusSecondaryHint {
  display: inline-block;
  line-height: 1;
  vertical-align: middle;
}
[dir="ltr"] .uppy-size--md .uppy-StatusBar-statusSecondaryHint{
  margin-right: 8px;
}
[dir="rtl"] .uppy-size--md .uppy-StatusBar-statusSecondaryHint{
  margin-left: 8px;
}

[dir="ltr"] .uppy-StatusBar-statusIndicator{
  margin-right: 7px;
}

[dir="rtl"] .uppy-StatusBar-statusIndicator{
  margin-left: 7px;
}

.uppy-StatusBar-statusIndicator {
  position: relative;
  top: 1px;
  color: #525252;
}
.uppy-StatusBar-statusIndicator svg {
  vertical-align: text-bottom;
}

[dir="ltr"] .uppy-StatusBar-actions{
  right: 10px;
}

[dir="rtl"] .uppy-StatusBar-actions{
  left: 10px;
}

.uppy-StatusBar-actions {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1004;
  display: flex;
  align-items: center;
}

.uppy-StatusBar.is-waiting .uppy-StatusBar-actions {
  position: static;
  width: 100%;
  height: 100%;
  padding: 0 15px;
  background-color: #fafafa;
}
[data-uppy-theme=dark] .uppy-StatusBar.is-waiting .uppy-StatusBar-actions {
  background-color: #1f1f1f;
}

.uppy-StatusBar:not([aria-hidden=true]).is-waiting.has-ghosts {
  flex-direction: column;
  height: 90px;
}
.uppy-size--md .uppy-StatusBar:not([aria-hidden=true]).is-waiting.has-ghosts {
  flex-direction: row;
  height: 65px;
}
.uppy-StatusBar:not([aria-hidden=true]).is-waiting.has-ghosts .uppy-StatusBar-actions {
  flex-direction: column;
  justify-content: center;
}
.uppy-size--md .uppy-StatusBar:not([aria-hidden=true]).is-waiting.has-ghosts .uppy-StatusBar-actions {
  flex-direction: row;
  justify-content: initial;
}

.uppy-StatusBar-actionCircleBtn {
  margin: 3px;
  line-height: 1;
  cursor: pointer;
  opacity: 0.9;
}
.uppy-StatusBar-actionCircleBtn:focus {
  outline: none;
}
.uppy-StatusBar-actionCircleBtn::-moz-focus-inner {
  border: 0;
}
.uppy-StatusBar-actionCircleBtn:focus {
  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.5);
}
[data-uppy-theme=dark] .uppy-StatusBar-actionCircleBtn:focus {
  outline: none;
}
[data-uppy-theme=dark] .uppy-StatusBar-actionCircleBtn::-moz-focus-inner {
  border: 0;
}
[data-uppy-theme=dark] .uppy-StatusBar-actionCircleBtn:focus {
  box-shadow: 0 0 0 2px rgba(170, 225, 255, 0.85);
}
.uppy-StatusBar-actionCircleBtn:hover {
  opacity: 1;
}
.uppy-StatusBar-actionCircleBtn:focus {
  border-radius: 50%;
}

.uppy-StatusBar-actionCircleBtn svg {
  vertical-align: bottom;
}

.uppy-StatusBar-actionBtn {
  display: inline-block;
  color: #1269cf;
  font-size: 10px;
  line-height: inherit;
  vertical-align: middle;
}
.uppy-size--md .uppy-StatusBar-actionBtn {
  font-size: 11px;
}

.uppy-StatusBar-actionBtn--disabled {
  opacity: 0.4;
}
[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--disabled {
  opacity: 0.7;
}

[dir="ltr"] .uppy-StatusBar-actionBtn--retry{
  margin-right: 6px;
}

[dir="rtl"] .uppy-StatusBar-actionBtn--retry{
  margin-left: 6px;
}

.uppy-StatusBar-actionBtn--retry {
  position: relative;
  height: 16px;
  padding: 1px 6px 3px 18px;
  color: #fff;
  line-height: 1;
  background-color: #ff4b23;
  border-radius: 8px;
}
.uppy-StatusBar-actionBtn--retry:focus {
  outline: none;
}
.uppy-StatusBar-actionBtn--retry::-moz-focus-inner {
  border: 0;
}
.uppy-StatusBar-actionBtn--retry:focus {
  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.5);
}
[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--retry:focus {
  outline: none;
}
[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--retry::-moz-focus-inner {
  border: 0;
}
[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--retry:focus {
  box-shadow: 0 0 0 2px rgba(170, 225, 255, 0.85);
}
.uppy-StatusBar-actionBtn--retry:hover {
  background-color: #f92d00;
}
[dir="ltr"] .uppy-StatusBar-actionBtn--retry svg{
  left: 6px;
}
[dir="rtl"] .uppy-StatusBar-actionBtn--retry svg{
  right: 6px;
}
.uppy-StatusBar-actionBtn--retry svg {
  position: absolute;
  top: 3px;
}

.uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload {
  width: 100%;
  padding: 15px 10px;
  color: #fff;
  font-size: 14px;
  line-height: 1;
  background-color: #1bb240;
}
.uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload:hover {
  background-color: #189c38;
}
[data-uppy-theme=dark] .uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload {
  background-color: #1c8b37;
}
[data-uppy-theme=dark] .uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload:hover {
  background-color: #18762f;
}

.uppy-size--md .uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload {
  width: auto;
  padding: 13px 22px;
}

.uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload.uppy-StatusBar-actionBtn--disabled:hover {
  background-color: #1bb240;
  cursor: not-allowed;
}

[data-uppy-theme=dark] .uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload.uppy-StatusBar-actionBtn--disabled:hover {
  background-color: #1c8b37;
}

.uppy-StatusBar:not(.is-waiting) .uppy-StatusBar-actionBtn--upload {
  color: #1269cf;
  background-color: transparent;
}

[dir="ltr"] .uppy-StatusBar-actionBtn--uploadNewlyAdded{
  padding-right: 3px;
}

[dir="rtl"] .uppy-StatusBar-actionBtn--uploadNewlyAdded{
  padding-left: 3px;
}

[dir="ltr"] .uppy-StatusBar-actionBtn--uploadNewlyAdded{
  padding-left: 3px;
}

[dir="rtl"] .uppy-StatusBar-actionBtn--uploadNewlyAdded{
  padding-right: 3px;
}

.uppy-StatusBar-actionBtn--uploadNewlyAdded {
  padding-bottom: 1px;
  border-radius: 3px;
}
.uppy-StatusBar-actionBtn--uploadNewlyAdded:focus {
  outline: none;
}
.uppy-StatusBar-actionBtn--uploadNewlyAdded::-moz-focus-inner {
  border: 0;
}
.uppy-StatusBar-actionBtn--uploadNewlyAdded:focus {
  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.5);
}
[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--uploadNewlyAdded:focus {
  outline: none;
}
[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--uploadNewlyAdded::-moz-focus-inner {
  border: 0;
}
[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--uploadNewlyAdded:focus {
  box-shadow: 0 0 0 2px rgba(170, 225, 255, 0.85);
}
.uppy-StatusBar.is-preprocessing .uppy-StatusBar-actionBtn--uploadNewlyAdded, .uppy-StatusBar.is-postprocessing .uppy-StatusBar-actionBtn--uploadNewlyAdded {
  display: none;
}

.uppy-StatusBar-actionBtn--done {
  padding: 7px 8px;
  line-height: 1;
  border-radius: 3px;
}
.uppy-StatusBar-actionBtn--done:focus {
  outline: none;
}
.uppy-StatusBar-actionBtn--done::-moz-focus-inner {
  border: 0;
}
.uppy-StatusBar-actionBtn--done:hover {
  color: #0e51a0;
}
.uppy-StatusBar-actionBtn--done:focus {
  background-color: #dfe6f1;
}
[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--done:focus {
  background-color: #333;
}
[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--done {
  color: #02baf2;
}

.uppy-size--md .uppy-StatusBar-actionBtn--done {
  font-size: 14px;
}

.uppy-StatusBar-serviceMsg {
  padding-left: 10px;
  color: #000;
  font-size: 11px;
  line-height: 1.1;
}
.uppy-size--md .uppy-StatusBar-serviceMsg {
  padding-left: 15px;
  font-size: 14px;
}
[data-uppy-theme=dark] .uppy-StatusBar-serviceMsg {
  color: #eaeaea;
}

.uppy-StatusBar-serviceMsg-ghostsIcon {
  position: relative;
  top: 2px;
  left: 6px;
  width: 10px;
  vertical-align: text-bottom;
  opacity: 0.5;
}
.uppy-size--md .uppy-StatusBar-serviceMsg-ghostsIcon {
  top: 1px;
  left: 10px;
  width: 15px;
}

[dir="ltr"] .uppy-StatusBar-details{
  left: 2px;
}

[dir="rtl"] .uppy-StatusBar-details{
  right: 2px;
}

.uppy-StatusBar-details {
  position: relative;
  top: 0;
  display: inline-block;
  width: 13px;
  height: 13px;
  color: #fff;
  font-weight: 600;
  font-size: 10px;
  line-height: 12px;
  text-align: center;
  vertical-align: middle;
  background-color: #939393;
  border-radius: 50%;
  cursor: help;
  -webkit-appearance: none;
          -moz-appearance: none;
       appearance: none;
}

.uppy-StatusBar-details::after {
  line-height: 1.3;
  word-wrap: break-word;
}

[dir="ltr"] .uppy-StatusBar-spinner{
  margin-right: 10px;
}

[dir="rtl"] .uppy-StatusBar-spinner{
  margin-left: 10px;
}

.uppy-StatusBar-spinner {
  animation-name: uppy-StatusBar-spinnerAnimation;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  fill: #1269cf;
}

.uppy-StatusBar.is-preprocessing .uppy-StatusBar-spinner,
.uppy-StatusBar.is-postprocessing .uppy-StatusBar-spinner {
  fill: #f6a623;
}

@keyframes uppy-StatusBar-spinnerAnimation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.uppy-ProviderBrowser-viewType--grid ul.uppy-ProviderBrowser-list,
.uppy-ProviderBrowser-viewType--unsplash ul.uppy-ProviderBrowser-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  padding: 6px;
}
.uppy-ProviderBrowser-viewType--grid ul.uppy-ProviderBrowser-list::after,
.uppy-ProviderBrowser-viewType--unsplash ul.uppy-ProviderBrowser-list::after {
  flex: auto;
  content: "";
}
.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem,
.uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem {
  position: relative;
  width: 50%;
  margin: 0;
}
.uppy-size--md .uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem,
.uppy-size--md .uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem {
  width: 33.3333%;
}
.uppy-size--lg .uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem,
.uppy-size--lg .uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem {
  width: 25%;
}
.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem::before,
.uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem::before {
  display: block;
  padding-top: 100%;
  content: "";
}
.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--selected img,
.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--selected svg,
.uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem--selected img,
.uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem--selected svg {
  opacity: 0.85;
}
.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--disabled,
.uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem--disabled {
  opacity: 0.5;
}
.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--noPreview .uppy-ProviderBrowserItem-inner,
.uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem--noPreview .uppy-ProviderBrowserItem-inner {
  background-color: rgba(147, 147, 147, 0.2);
}
[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--noPreview .uppy-ProviderBrowserItem-inner,
[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem--noPreview .uppy-ProviderBrowserItem-inner {
  background-color: rgba(234, 234, 234, 0.2);
}
.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--noPreview svg,
.uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem--noPreview svg {
  width: 30%;
  height: 30%;
  fill: rgba(0, 0, 0, 0.7);
}
[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--noPreview svg,
[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem--noPreview svg {
  fill: rgba(255, 255, 255, 0.8);
}
.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-inner,
.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-inner {
  position: absolute;
  top: 7px;
  right: 7px;
  bottom: 7px;
  left: 7px;
  width: calc(100% - 14px);
  height: calc(100% - 14px);
  overflow: hidden;
  text-align: center;
  border-radius: 4px;
}
@media (hover: none) {
  .uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-inner .uppy-ProviderBrowserItem-author,
  .uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-inner .uppy-ProviderBrowserItem-author {
    display: block;
  }
}
[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-inner,
[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-inner {
  box-shadow: 0 0 0 3px rgba(170, 225, 255, 0.7);
}
.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-inner img,
.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-inner img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  border-radius: 4px;
}
.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-author,
.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-author {
  position: absolute;
  display: none;
  bottom: 0;
  left: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  color: white;
  font-weight: 500;
  font-size: 12px;
  margin: 0;
  padding: 5px;
  -webkit-text-decoration: none;
  text-decoration: none;
}
.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-author:hover,
.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-author:hover {
  background: rgba(0, 0, 0, 0.4);
  -webkit-text-decoration: underline;
  text-decoration: underline;
}
.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox,
.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1002;
  width: 26px;
  height: 26px;
  background-color: #1269cf;
  border-radius: 50%;
  opacity: 0;
}
[dir="ltr"] .uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox::after,[dir="ltr"] 
.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox::after{
  left: 7px;
}
[dir="rtl"] .uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox::after,[dir="rtl"] 
.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox::after{
  right: 7px;
}
.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox::after,
.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox::after {
  top: 8px;
  width: 12px;
  height: 7px;
}
.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem--is-checked .uppy-ProviderBrowserItem-checkbox,
.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem--is-checked .uppy-ProviderBrowserItem-checkbox {
  opacity: 1;
}
.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox--grid:hover + label .uppy-ProviderBrowserItem-author,
.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox--grid:focus + label .uppy-ProviderBrowserItem-author,
.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox--grid:hover + label .uppy-ProviderBrowserItem-author,
.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox--grid:focus + label .uppy-ProviderBrowserItem-author {
  display: block;
}
.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox--grid:focus + label,
.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox--grid:focus + label {
  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.5);
}
.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox--grid:focus + label:focus,
.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox--grid:focus + label:focus {
  outline: none;
}
.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox--grid:focus + label::-moz-focus-inner,
.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox--grid:focus + label::-moz-focus-inner {
  border: 0;
}

.uppy-ProviderBrowser-viewType--list {
  background-color: #fff;
}
[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--list {
  background-color: #1f1f1f;
}
.uppy-ProviderBrowser-viewType--list li.uppy-ProviderBrowserItem {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 7px 15px;
}
[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--list li.uppy-ProviderBrowserItem {
  color: #eaeaea;
}
.uppy-ProviderBrowser-viewType--list li.uppy-ProviderBrowserItem--disabled {
  opacity: 0.6;
}
[dir="ltr"] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox{
  margin-right: 15px;
}
[dir="rtl"] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox{
  margin-left: 15px;
}
.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox {
  width: 17px;
  height: 17px;
  background-color: #fff;
  border: 1px solid #cfcfcf;
  border-radius: 3px;
}
.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox:focus {
  border: 1px solid #1269cf;
  outline: none;
  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.25);
}
[dir="ltr"] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox::after{
  left: 3px;
}
[dir="rtl"] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox::after{
  right: 3px;
}
.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox::after {
  top: 4px;
  width: 9px;
  height: 5px;
  opacity: 0;
}
[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox:focus {
  border-color: rgba(2, 186, 242, 0.7);
  box-shadow: 0 0 0 3px rgba(2, 186, 242, 0.2);
}
.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem--is-checked .uppy-ProviderBrowserItem-checkbox,
.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem--is-partial .uppy-ProviderBrowserItem-checkbox {
  background-color: #1269cf;
  border-color: #1269cf;
}
.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem--is-checked .uppy-ProviderBrowserItem-checkbox::after,
.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem--is-partial .uppy-ProviderBrowserItem-checkbox::after {
  opacity: 1;
}
.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner {
  display: flex;
  align-items: center;
  color: inherit;
  font-family: -apple-system, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, BlinkMacSystemFont, "Segoe UI", "Segoe UI Symbol", "Segoe UI Emoji", "Apple Color Emoji", Roboto, Helvetica, Arial, sans-serif;
  padding: 2px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner:focus {
  -webkit-text-decoration: underline;
  text-decoration: underline;
  outline: none;
}
[dir="ltr"] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner img,[dir="ltr"] 
.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner svg{
  margin-right: 8px;
}
[dir="rtl"] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner img,[dir="rtl"] 
.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner svg{
  margin-left: 8px;
}
.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner span {
  overflow: hidden;
  line-height: 1.2;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem--disabled .uppy-ProviderBrowserItem-inner {
  cursor: default;
}
[dir="ltr"] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-iconWrap{
  margin-right: 7px;
}
[dir="rtl"] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-iconWrap{
  margin-left: 7px;
}
.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-iconWrap {
  width: 20px;
}

.uppy-ProviderBrowserItem-checkbox {
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
}
.uppy-ProviderBrowserItem-checkbox:disabled {
  cursor: default;
}
.uppy-ProviderBrowserItem-checkbox:disabled::after {
  cursor: default;
}
[data-uppy-theme=dark] .uppy-ProviderBrowserItem-checkbox {
  background-color: #1f1f1f;
  border-color: #939393;
}

[data-uppy-theme=dark] .uppy-ProviderBrowserItem--is-checked .uppy-ProviderBrowserItem-checkbox {
  background-color: #333;
}
.uppy-ProviderBrowserItem--is-checked .uppy-ProviderBrowserItem-checkbox::after {
  position: absolute;
  border-bottom: 2px solid #eaeaea;
  border-left: 2px solid #eaeaea;
  transform: rotate(-45deg);
  cursor: pointer;
  content: "";
}

.uppy-ProviderBrowserItem--is-partial .uppy-ProviderBrowserItem-checkbox::after {
  content: "" !important;
  position: absolute !important;
  top: 50% !important;
  left: 20% !important;
  right: 20% !important;
  height: 2px !important;
  background-color: #eaeaea !important;
  transform: translateY(-50%) !important;
}

.uppy-SearchProvider {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
[data-uppy-theme=dark] .uppy-SearchProvider {
  background-color: #1f1f1f;
}

.uppy-SearchProvider-input {
  width: 90%;
  max-width: 650px;
  margin-bottom: 15px;
}
.uppy-size--md .uppy-SearchProvider-input {
  margin-bottom: 20px;
}
.uppy-SearchProvider-input::-webkit-search-cancel-button {
  display: none;
}

.uppy-SearchProvider-searchButton {
  padding: 13px 25px;
}
.uppy-size--md .uppy-SearchProvider-searchButton {
  padding: 13px 30px;
}

.uppy-DashboardContent-panelBody {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
}
[data-uppy-theme=dark] .uppy-DashboardContent-panelBody {
  background-color: #1f1f1f;
}

.uppy-Provider-auth,
.uppy-Provider-error,
.uppy-Provider-loading,
.uppy-Provider-empty {
  display: flex;
  flex: 1;
  flex-flow: column wrap;
  align-items: center;
  justify-content: center;
  color: #939393;
}

.uppy-Provider-empty {
  color: #939393;
}

.uppy-Provider-authIcon svg {
  width: 100px;
  height: 75px;
}

.uppy-Provider-authTitle {
  max-width: 500px;
  margin-bottom: 30px;
  padding: 0 15px;
  color: #757575;
  font-weight: 400;
  font-size: 17px;
  line-height: 1.4;
  text-align: center;
}
.uppy-size--md .uppy-Provider-authTitle {
  font-size: 20px;
}
[data-uppy-theme=dark] .uppy-Provider-authTitle {
  color: #cfcfcf;
}

.uppy-Provider-btn-google {
  display: flex;
  align-items: center;
  padding: 8px 12px !important;
  background: #4285f4;
}
.uppy-Provider-btn-google:hover {
  background-color: #1266f1;
}
.uppy-Provider-btn-google:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.4);
}
.uppy-Provider-btn-google svg {
  margin-right: 8px;
}

[dir="ltr"] .uppy-Provider-breadcrumbs{
  text-align: left;
}

[dir="rtl"] .uppy-Provider-breadcrumbs{
  text-align: right;
}

.uppy-Provider-breadcrumbs {
  flex: 1;
  margin-bottom: 10px;
  color: #525252;
  font-size: 12px;
}
.uppy-size--md .uppy-Provider-breadcrumbs {
  margin-bottom: 0;
}
[data-uppy-theme=dark] .uppy-Provider-breadcrumbs {
  color: #eaeaea;
}

[dir="ltr"] .uppy-Provider-breadcrumbsIcon{
  margin-right: 4px;
}

[dir="rtl"] .uppy-Provider-breadcrumbsIcon{
  margin-left: 4px;
}

.uppy-Provider-breadcrumbsIcon {
  display: inline-block;
  color: #525252;
  line-height: 1;
  vertical-align: middle;
}

.uppy-Provider-breadcrumbsIcon svg {
  width: 13px;
  height: 13px;
  fill: #525252;
}

.uppy-Provider-breadcrumbs button {
  display: inline-block;
  padding: 4px;
  line-height: inherit;
  border-radius: 3px;
}
.uppy-Provider-breadcrumbs button:focus {
  outline: none;
}
.uppy-Provider-breadcrumbs button::-moz-focus-inner {
  border: 0;
}
.uppy-Provider-breadcrumbs button:hover {
  color: #0e51a0;
}
.uppy-Provider-breadcrumbs button:focus {
  background-color: #dfe6f1;
}
[data-uppy-theme=dark] .uppy-Provider-breadcrumbs button:focus {
  background-color: #333;
}
.uppy-Provider-breadcrumbs button:not(:last-of-type) {
  -webkit-text-decoration: underline;
  text-decoration: underline;
}
.uppy-Provider-breadcrumbs button:last-of-type {
  color: #333;
  font-weight: 500;
  cursor: normal;
  pointer-events: none;
}
.uppy-Provider-breadcrumbs button:hover {
  cursor: pointer;
}
[data-uppy-theme=dark] .uppy-Provider-breadcrumbs button {
  color: #eaeaea;
}

.uppy-ProviderBrowser {
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  font-weight: 400;
  font-size: 14px;
}

.uppy-ProviderBrowser-user {
  margin: 0 8px 0 0;
  color: #333;
  font-weight: 500;
}
[data-uppy-theme=dark] .uppy-ProviderBrowser-user {
  color: #eaeaea;
}

[dir="ltr"] .uppy-ProviderBrowser-user::after{
  left: 4px;
}

[dir="rtl"] .uppy-ProviderBrowser-user::after{
  right: 4px;
}

.uppy-ProviderBrowser-user::after {
  position: relative;
  color: #939393;
  font-weight: normal;
  content: "·";
}

.uppy-ProviderBrowser-header {
  position: relative;
  z-index: 1001;
  border-bottom: 1px solid #eaeaea;
}
[data-uppy-theme=dark] .uppy-ProviderBrowser-header {
  border-bottom: 1px solid #333;
}

.uppy-ProviderBrowser-headerBar {
  z-index: 1001;
  padding: 7px 15px;
  color: #757575;
  font-size: 12px;
  line-height: 1.4;
  background-color: #fafafa;
}
.uppy-size--md .uppy-ProviderBrowser-headerBar {
  display: flex;
  align-items: center;
}
[data-uppy-theme=dark] .uppy-ProviderBrowser-headerBar {
  background-color: #1f1f1f;
}

.uppy-ProviderBrowser-headerBar--simple {
  display: block;
  justify-content: center;
  text-align: center;
}

.uppy-ProviderBrowser-headerBar--simple .uppy-Provider-breadcrumbsWrap {
  display: inline-block;
  flex: none;
  vertical-align: middle;
}

.uppy-ProviderBrowser-searchFilter {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 30px;
  padding-left: 8px;
  padding-right: 8px;
  margin-top: 15px;
  margin-bottom: 15px;
}

[dir="ltr"] .uppy-ProviderBrowser-searchFilterInput{
  padding-left: 30px;
}

[dir="rtl"] .uppy-ProviderBrowser-searchFilterInput{
  padding-right: 30px;
}

[dir="ltr"] .uppy-ProviderBrowser-searchFilterInput{
  padding-right: 30px;
}

[dir="rtl"] .uppy-ProviderBrowser-searchFilterInput{
  padding-left: 30px;
}

.uppy-ProviderBrowser-searchFilterInput {
  z-index: 1001;
  width: 100%;
  height: 30px;
  font-size: 13px;
  font-family: -apple-system, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, BlinkMacSystemFont, "Segoe UI", "Segoe UI Symbol", "Segoe UI Emoji", "Apple Color Emoji", Roboto, Helvetica, Arial, sans-serif;
  line-height: 1.4;
  background-color: #eaeaea;
  border: 0;
  border-radius: 4px;
  outline: 0;
  color: #333;
}
.uppy-ProviderBrowser-searchFilterInput::-webkit-search-cancel-button {
  display: none;
}
[data-uppy-theme=dark] .uppy-ProviderBrowser-searchFilterInput {
  color: #eaeaea;
  background-color: #1f1f1f;
}

.uppy-ProviderBrowser-searchFilterInput:focus {
  background-color: #cfcfcf;
  border: 0;
}
[data-uppy-theme=dark] .uppy-ProviderBrowser-searchFilterInput:focus {
  background-color: #333;
}

[dir="ltr"] .uppy-ProviderBrowser-searchFilterIcon{
  left: 16px;
}

[dir="rtl"] .uppy-ProviderBrowser-searchFilterIcon{
  right: 16px;
}

.uppy-ProviderBrowser-searchFilterIcon {
  position: absolute;
  z-index: 1002;
  width: 12px;
  height: 12px;
  color: #757575;
}

.uppy-ProviderBrowser-searchFilterInput::-moz-placeholder {
  color: #939393;
  opacity: 1;
}

.uppy-ProviderBrowser-searchFilterInput::placeholder {
  color: #939393;
  opacity: 1;
}

[dir="ltr"] .uppy-ProviderBrowser-searchFilterReset{
  right: 16px;
}

[dir="rtl"] .uppy-ProviderBrowser-searchFilterReset{
  left: 16px;
}

.uppy-ProviderBrowser-searchFilterReset {
  border-radius: 3px;
  position: absolute;
  z-index: 1002;
  width: 22px;
  height: 22px;
  padding: 6px;
  color: #939393;
  cursor: pointer;
}
.uppy-ProviderBrowser-searchFilterReset:focus {
  outline: none;
}
.uppy-ProviderBrowser-searchFilterReset::-moz-focus-inner {
  border: 0;
}
.uppy-ProviderBrowser-searchFilterReset:focus {
  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.5);
}
.uppy-ProviderBrowser-searchFilterReset:hover {
  color: #757575;
}
.uppy-ProviderBrowser-searchFilterReset svg {
  vertical-align: text-top;
}

.uppy-ProviderBrowser-userLogout {
  padding: 4px;
  color: #1269cf;
  line-height: inherit;
  border-radius: 3px;
  cursor: pointer;
}
.uppy-ProviderBrowser-userLogout:focus {
  outline: none;
}
.uppy-ProviderBrowser-userLogout::-moz-focus-inner {
  border: 0;
}
.uppy-ProviderBrowser-userLogout:hover {
  color: #0e51a0;
}
.uppy-ProviderBrowser-userLogout:focus {
  background-color: #dfe6f1;
}
[data-uppy-theme=dark] .uppy-ProviderBrowser-userLogout:focus {
  background-color: #333;
}
.uppy-ProviderBrowser-userLogout:hover {
  -webkit-text-decoration: underline;
  text-decoration: underline;
}
[data-uppy-theme=dark] .uppy-ProviderBrowser-userLogout {
  color: #eaeaea;
}

.uppy-ProviderBrowser-body {
  position: relative;
  flex: 1;
}

.uppy-ProviderBrowser-list {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  flex: 1;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  list-style: none;
  background-color: #fff;
  border-spacing: 0;
  -webkit-overflow-scrolling: touch;
}
[data-uppy-theme=dark] .uppy-ProviderBrowser-list {
  background-color: #1f1f1f;
}
.uppy-ProviderBrowser-list:focus {
  outline: none;
}

.uppy-ProviderBrowserItem-inner {
  font-weight: 500;
  font-size: 13px;
  cursor: pointer;
}

.uppy-ProviderBrowser-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  background-color: #fff;
  border-top: 1px solid #eaeaea;
}
[dir="ltr"] .uppy-ProviderBrowser-footer button{
  margin-right: 8px;
}
[dir="rtl"] .uppy-ProviderBrowser-footer button{
  margin-left: 8px;
}
[data-uppy-theme=dark] .uppy-ProviderBrowser-footer {
  background-color: #1f1f1f;
  border-top: 1px solid #333;
}

.uppy-ProviderBrowser-footer-buttons {
  flex-shrink: 0;
}

.uppy-ProviderBrowser-footer-error {
  color: #e32437;
  line-height: 18px;
}

@media (max-width: 426px) {
  .uppy-ProviderBrowser-footer {
    flex-direction: column-reverse;
    align-items: stretch;
  }
  .uppy-ProviderBrowser-footer-error {
    padding-bottom: 10px;
  }
}
/* https://stackoverflow.com/a/33082658/6519037 */
.picker-dialog-bg {
  z-index: 20000 !important;
}

.picker-dialog {
  z-index: 20001 !important;
}

.uppy-Dashboard-Item-previewInnerWrap {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 3px;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.4);
}
.uppy-size--md .uppy-Dashboard-Item-previewInnerWrap {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
}
.uppy-Dashboard--singleFile .uppy-Dashboard-Item-previewInnerWrap {
  box-shadow: none;
}

.uppy-Dashboard-Item-previewInnerWrap::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1001;
  display: none;
  background-color: rgba(0, 0, 0, 0.65);
  content: "";
}

.uppy-Dashboard-Item-previewLink {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1002;
}
.uppy-Dashboard-Item-previewLink:focus {
  box-shadow: inset 0 0 0 3px #579df0;
}
[data-uppy-theme=dark] .uppy-Dashboard-Item-previewLink:focus {
  box-shadow: inset 0 0 0 3px #016c8d;
}

.uppy-Dashboard-Item-preview img.uppy-Dashboard-Item-previewImg {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  border-radius: 3px;
  transform: translateZ(0);
}
.uppy-Dashboard--singleFile .uppy-Dashboard-Item-preview img.uppy-Dashboard-Item-previewImg {
  -o-object-fit: contain;
     object-fit: contain;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  padding: 10px;
}

.uppy-Dashboard-Item-progress {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1002;
  width: 120px;
  color: #fff;
  text-align: center;
  transform: translate(-50%, -50%);
  transition: all 0.35 ease;
}

.uppy-Dashboard-Item-progressIndicator {
  display: inline-block;
  width: 38px;
  height: 38px;
  opacity: 0.9;
  color: #fff;
}
.uppy-size--md .uppy-Dashboard-Item-progressIndicator {
  width: 55px;
  height: 55px;
}

button.uppy-Dashboard-Item-progressIndicator {
  cursor: pointer;
}
button.uppy-Dashboard-Item-progressIndicator:focus {
  outline: none;
}
button.uppy-Dashboard-Item-progressIndicator::-moz-focus-inner {
  border: 0;
}
button.uppy-Dashboard-Item-progressIndicator:focus .uppy-Dashboard-Item-progressIcon--bg,
button.uppy-Dashboard-Item-progressIndicator:focus .uppy-Dashboard-Item-progressIcon--retry {
  fill: #579df0;
}

.uppy-Dashboard-Item-progressIcon--circle {
  width: 100%;
  height: 100%;
}

.uppy-Dashboard-Item-progressIcon--bg {
  stroke: rgba(255, 255, 255, 0.4);
}

.uppy-Dashboard-Item-progressIcon--progress {
  transition: stroke-dashoffset 0.5s ease-out;
  stroke: #fff;
}

.uppy-Dashboard-Item-progressIcon--play {
  transition: all 0.2s;
  fill: #fff;
  stroke: #fff;
}

.uppy-Dashboard-Item-progressIcon--cancel {
  transition: all 0.2s;
  fill: #fff;
}

.uppy-Dashboard-Item-progressIcon--pause {
  transition: all 0.2s;
  fill: #fff;
  stroke: #fff;
}

.uppy-Dashboard-Item-progressIcon--check {
  transition: all 0.2s;
  fill: #fff;
}

.uppy-Dashboard-Item-progressIcon--retry {
  fill: #fff;
}

[dir="ltr"] .uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progress{
  right: -8px;
}

[dir="rtl"] .uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progress{
  left: -8px;
}

[dir="ltr"] .uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progress{
  left: auto;
  left: initial;
}

[dir="rtl"] .uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progress{
  right: auto;
  right: initial;
}

.uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progress {
  top: -9px;
  width: auto;
  transform: none;
  transform: initial;
}

.uppy-Dashboard-Item.is-error .uppy-Dashboard-Item-progressIndicator {
  width: 18px;
  height: 18px;
}
.uppy-size--md .uppy-Dashboard-Item.is-error .uppy-Dashboard-Item-progressIndicator {
  width: 28px;
  height: 28px;
}

.uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progressIndicator {
  width: 18px;
  height: 18px;
  opacity: 1;
}
.uppy-size--md .uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progressIndicator {
  width: 22px;
  height: 22px;
}

.uppy-Dashboard-Item.is-processing .uppy-Dashboard-Item-progress {
  opacity: 0;
}

[dir="ltr"] .uppy-Dashboard-Item-fileInfo{
  padding-right: 5px;
}

[dir="rtl"] .uppy-Dashboard-Item-fileInfo{
  padding-left: 5px;
}
[dir="ltr"] .uppy-Dashboard--singleFile .uppy-Dashboard-Item-fileInfo{
  padding-right: 10px;
}
[dir="rtl"] .uppy-Dashboard--singleFile .uppy-Dashboard-Item-fileInfo{
  padding-left: 10px;
}
[dir="ltr"] .uppy-size--md.uppy-Dashboard--singleFile .uppy-Dashboard-Item-fileInfo{
  padding-right: 15px;
}
[dir="rtl"] .uppy-size--md.uppy-Dashboard--singleFile .uppy-Dashboard-Item-fileInfo{
  padding-left: 15px;
}

.uppy-Dashboard-Item-name {
  margin-bottom: 5px;
  font-weight: 500;
  font-size: 12px;
  line-height: 1.3;
  word-wrap: anywhere;
  word-break: break-all;
}
[data-uppy-theme=dark] .uppy-Dashboard-Item-name {
  color: #eaeaea;
}
.uppy-size--md.uppy-Dashboard--singleFile .uppy-Dashboard-Item-name {
  font-size: 14px;
  line-height: 1.4;
}

.uppy-Dashboard-Item-fileName {
  display: flex;
  align-items: baseline;
}
.uppy-Dashboard-Item-fileName button {
  margin-left: 5px;
}

.uppy-Dashboard-Item-author {
  color: #757575;
  vertical-align: bottom;
  font-size: 11px;
  font-weight: normal;
  display: inline-block;
  line-height: 1;
  margin-bottom: 5px;
}
.uppy-Dashboard-Item-author a {
  color: #757575;
}

.uppy-Dashboard-Item-status {
  color: #757575;
  font-weight: normal;
  font-size: 11px;
  line-height: 1;
}
[data-uppy-theme=dark] .uppy-Dashboard-Item-status {
  color: #bbb;
}

.uppy-Dashboard-Item-statusSize {
  display: inline-block;
  text-transform: uppercase;
  vertical-align: bottom;
  margin-bottom: 5px;
}

.uppy-Dashboard-Item-reSelect {
  color: #1269cf;
  font-weight: 600;
  font-size: inherit;
  font-family: inherit;
}

.uppy-Dashboard-Item-errorMessage {
  font-size: 11px;
  font-weight: 500;
  line-height: 1.3;
  color: #a51523;
  background-color: #fdeff1;
  padding: 5px 6px;
}

.uppy-Dashboard-Item-errorMessageBtn {
  font-size: 11px;
  -webkit-text-decoration: underline;
  text-decoration: underline;
  color: #a51523;
  cursor: pointer;
  font-weight: 500;
}

.uppy-Dashboard-Item-preview .uppy-Dashboard-Item-errorMessage {
  display: none;
}
.uppy-size--md .uppy-Dashboard-Item-preview .uppy-Dashboard-Item-errorMessage {
  display: block;
  border-top: 1px solid #f7c2c8;
  padding: 6px 8px;
  line-height: 1.4;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.uppy-Dashboard-Item-fileInfo .uppy-Dashboard-Item-errorMessage {
  display: inline-block;
  position: static;
  border: 1px solid #f7c2c8;
  border-radius: 3px;
}
.uppy-size--md .uppy-Dashboard-Item-fileInfo .uppy-Dashboard-Item-errorMessage {
  display: none;
}

.uppy-Dashboard-Item-action {
  color: #939393;
  cursor: pointer;
}
.uppy-Dashboard-Item-action:focus {
  outline: none;
}
.uppy-Dashboard-Item-action::-moz-focus-inner {
  border: 0;
}
.uppy-Dashboard-Item-action:focus {
  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.5);
}
.uppy-Dashboard-Item-action:hover {
  color: #1f1f1f;
  opacity: 1;
}
[data-uppy-theme=dark] .uppy-Dashboard-Item-action {
  color: #cfcfcf;
}
[data-uppy-theme=dark] .uppy-Dashboard-Item-action:focus {
  outline: none;
}
[data-uppy-theme=dark] .uppy-Dashboard-Item-action::-moz-focus-inner {
  border: 0;
}
[data-uppy-theme=dark] .uppy-Dashboard-Item-action:focus {
  box-shadow: 0 0 0 2px rgba(170, 225, 255, 0.85);
}
[data-uppy-theme=dark] .uppy-Dashboard-Item-action:hover {
  color: #eaeaea;
}

.uppy-Dashboard-Item-action--remove {
  color: #1f1f1f;
  opacity: 0.95;
}
.uppy-Dashboard-Item-action--remove:hover {
  color: #000;
  opacity: 1;
}
[dir="ltr"] .uppy-size--md .uppy-Dashboard-Item-action--remove{
  right: -8px;
}
[dir="rtl"] .uppy-size--md .uppy-Dashboard-Item-action--remove{
  left: -8px;
}
.uppy-size--md .uppy-Dashboard-Item-action--remove {
  position: absolute;
  top: -8px;
  z-index: 1002;
  width: 18px;
  height: 18px;
  padding: 0;
}
.uppy-size--md .uppy-Dashboard-Item-action--remove:focus {
  border-radius: 50%;
}
[dir="ltr"] .uppy-Dashboard--singleFile.uppy-size--height-md .uppy-Dashboard-Item-action--remove{
  right: 8px;
}
[dir="rtl"] .uppy-Dashboard--singleFile.uppy-size--height-md .uppy-Dashboard-Item-action--remove{
  left: 8px;
}
.uppy-Dashboard--singleFile.uppy-size--height-md .uppy-Dashboard-Item-action--remove {
  position: absolute;
  top: 8px;
}
[data-uppy-theme=dark] .uppy-Dashboard-Item-action--remove {
  color: #525252;
}
[data-uppy-theme=dark] .uppy-Dashboard-Item-action--remove:hover {
  color: #333;
}

.uppy-Dashboard:not(.uppy-size--md):not(.uppy-Dashboard--singleFile.uppy-size--height-md) .uppy-Dashboard-Item-actionWrapper {
  display: flex;
  align-items: center;
}
.uppy-Dashboard:not(.uppy-size--md):not(.uppy-Dashboard--singleFile.uppy-size--height-md) .uppy-Dashboard-Item-action {
  width: 22px;
  height: 22px;
  margin-left: 3px;
  padding: 3px;
}
.uppy-Dashboard:not(.uppy-size--md):not(.uppy-Dashboard--singleFile.uppy-size--height-md) .uppy-Dashboard-Item-action:focus {
  border-radius: 3px;
}

.uppy-size--md .uppy-Dashboard-Item-action--copyLink,
.uppy-size--md .uppy-Dashboard-Item-action--edit {
  width: 16px;
  height: 16px;
  padding: 0;
}
.uppy-size--md .uppy-Dashboard-Item-action--copyLink:focus,
.uppy-size--md .uppy-Dashboard-Item-action--edit:focus {
  border-radius: 3px;
}

.uppy-Dashboard-Item {
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #eaeaea;
}
[dir="ltr"] .uppy-Dashboard:not(.uppy-Dashboard--singleFile) .uppy-Dashboard-Item{
  padding-right: 0;
}
[dir="rtl"] .uppy-Dashboard:not(.uppy-Dashboard--singleFile) .uppy-Dashboard-Item{
  padding-left: 0;
}
[data-uppy-theme=dark] .uppy-Dashboard-Item {
  border-bottom: 1px solid #333;
}
[dir="ltr"] .uppy-size--md .uppy-Dashboard-Item{
  float: left;
}
[dir="rtl"] .uppy-size--md .uppy-Dashboard-Item{
  float: right;
}
.uppy-size--md .uppy-Dashboard-Item {
  position: relative;
  display: block;
  /* When changing width: also update \`itemsPerRow\` values in \`src/components/Dashboard.js\`. */
  width: calc(33.333% - 15px - 15px);
  height: 215px;
  margin: 5px 15px;
  padding: 0;
  border-bottom: 0;
}
.uppy-size--lg .uppy-Dashboard-Item {
  /* When changing width: also update \`itemsPerRow\` values in \`src/components/Dashboard.js\`. */
  width: calc(25% - 15px - 15px);
  height: 190px;
  margin: 5px 15px;
  padding: 0;
}
.uppy-size--xl .uppy-Dashboard-Item {
  /* When changing width: also update \`itemsPerRow\` values in \`src/components/Dashboard.js\`. */
  width: calc(20% - 15px - 15px);
  height: 210px;
  padding: 0;
}
.uppy-Dashboard--singleFile .uppy-Dashboard-Item {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 400px;
  height: 100%;
  border-bottom: 0;
  position: relative;
  padding: 15px;
}

.uppy-Dashboard-Item.is-ghost .uppy-Dashboard-Item-previewInnerWrap {
  opacity: 0.2;
}

.uppy-Dashboard-Item.is-ghost .uppy-Dashboard-Item-name {
  opacity: 0.7;
}

.uppy-Dashboard-Item.is-ghost .uppy-Dashboard-Item-preview::before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1005;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-position: 50% 10px;
  background-size: 25px;
  opacity: 0.5;
  content: "";
}
.uppy-size--md .uppy-Dashboard-Item.is-ghost .uppy-Dashboard-Item-preview::before {
  background-position: 50% 50%;
  background-size: 40px;
}
.uppy-Dashboard--singleFile .uppy-Dashboard-Item.is-ghost .uppy-Dashboard-Item-preview::before {
  background-position: 50% 50%;
  background-size: 30%;
}

.uppy-Dashboard-Item-preview {
  position: relative;
  flex-grow: 0;
  flex-shrink: 0;
  width: 50px;
  height: 50px;
}
.uppy-size--md .uppy-Dashboard-Item-preview {
  width: 100%;
  height: 140px;
}
.uppy-size--lg .uppy-Dashboard-Item-preview {
  height: 120px;
}
.uppy-size--xl .uppy-Dashboard-Item-preview {
  height: 140px;
}
.uppy-Dashboard--singleFile .uppy-Dashboard-Item-preview {
  width: 100%;
  max-height: 75%;
  flex-grow: 1;
}
.uppy-Dashboard--singleFile.uppy-size--md .uppy-Dashboard-Item-preview {
  max-height: 100%;
}

[dir="ltr"] .uppy-Dashboard-Item-fileInfoAndButtons{
  padding-right: 8px;
}

[dir="rtl"] .uppy-Dashboard-Item-fileInfoAndButtons{
  padding-left: 8px;
}

[dir="ltr"] .uppy-Dashboard-Item-fileInfoAndButtons{
  padding-left: 12px;
}

[dir="rtl"] .uppy-Dashboard-Item-fileInfoAndButtons{
  padding-right: 12px;
}

.uppy-Dashboard-Item-fileInfoAndButtons {
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: space-between;
}
.uppy-size--md .uppy-Dashboard-Item-fileInfoAndButtons, .uppy-Dashboard--singleFile .uppy-Dashboard-Item-fileInfoAndButtons {
  align-items: flex-start;
  padding: 0;
  padding-top: 9px;
}
.uppy-Dashboard--singleFile .uppy-Dashboard-Item-fileInfoAndButtons {
  width: 100%;
  flex-grow: 0;
}

.uppy-Dashboard-Item-fileInfo {
  flex-grow: 1;
  flex-shrink: 1;
}

.uppy-Dashboard-Item-actionWrapper {
  flex-grow: 0;
  flex-shrink: 0;
}

.uppy-Dashboard-Item.is-inprogress .uppy-Dashboard-Item-previewInnerWrap::after,
.uppy-Dashboard-Item.is-error .uppy-Dashboard-Item-previewInnerWrap::after {
  display: block;
}

[dir="ltr"] .uppy-Dashboard-Item-errorDetails{
  left: 2px;
}

[dir="rtl"] .uppy-Dashboard-Item-errorDetails{
  right: 2px;
}

.uppy-Dashboard-Item-errorDetails {
  position: relative;
  top: 0;
  flex-shrink: 0;
  width: 13px;
  height: 13px;
  color: #fff;
  font-weight: 600;
  font-size: 10px;
  line-height: 12px;
  text-align: center;
  background-color: #939393;
  border-radius: 50%;
  border: none;
  cursor: help;
  -webkit-appearance: none;
          -moz-appearance: none;
       appearance: none;
}

.uppy-Dashboard-Item-errorDetails::after {
  line-height: 1.3;
  word-wrap: break-word;
}

.uppy-Dashboard-FileCard {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1005;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 10px 4px rgba(0, 0, 0, 0.1);
}
.uppy-Dashboard-FileCard .uppy-DashboardContent-bar {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.uppy-Dashboard-FileCard .uppy-Dashboard-FileCard-actions {
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}

.uppy-Dashboard-FileCard-inner {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  height: 100%;
  min-height: 0;
}

.uppy-Dashboard-FileCard-preview {
  position: relative;
  display: flex;
  flex-grow: 0;
  flex-shrink: 1;
  align-items: center;
  justify-content: center;
  height: 60%;
  min-height: 0;
  border-bottom: 1px solid #eaeaea;
}
[data-uppy-theme=dark] .uppy-Dashboard-FileCard-preview {
  background-color: #333;
  border-bottom: 0;
}

.uppy-Dashboard-FileCard-preview img.uppy-Dashboard-Item-previewImg {
  flex: 0 0 auto;
  max-width: 90%;
  max-height: 90%;
  -o-object-fit: cover;
     object-fit: cover;
  border-radius: 3px;
  box-shadow: 0 3px 20px rgba(0, 0, 0, 0.15);
}

[dir="ltr"] .uppy-Dashboard-FileCard-edit{
  right: 10px;
}

[dir="rtl"] .uppy-Dashboard-FileCard-edit{
  left: 10px;
}

.uppy-Dashboard-FileCard-edit {
  position: absolute;
  top: 10px;
  padding: 7px 15px;
  color: #fff;
  font-size: 13px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50px;
}
.uppy-Dashboard-FileCard-edit:focus {
  outline: none;
}
.uppy-Dashboard-FileCard-edit::-moz-focus-inner {
  border: 0;
}
.uppy-Dashboard-FileCard-edit:focus {
  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.5);
}
.uppy-Dashboard-FileCard-edit:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

.uppy-Dashboard-FileCard-info {
  flex-grow: 0;
  flex-shrink: 0;
  height: 40%;
  padding: 30px 20px 20px 20px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
[data-uppy-theme=dark] .uppy-Dashboard-FileCard-info {
  background-color: #1f1f1f;
}

.uppy-Dashboard-FileCard-fieldset {
  max-width: 640px;
  margin: auto;
  margin-bottom: 12px;
  padding: 0;
  font-size: 0;
  border: 0;
}

.uppy-Dashboard-FileCard-label {
  display: inline-block;
  width: 22%;
  color: #525252;
  font-size: 12px;
  vertical-align: middle;
}
.uppy-size--md .uppy-Dashboard-FileCard-label {
  font-size: 14px;
}
[data-uppy-theme=dark] .uppy-Dashboard-FileCard-label {
  color: #eaeaea;
}

.uppy-Dashboard-FileCard-input {
  display: inline-block;
  width: 78%;
  vertical-align: middle;
}

.uppy-Dashboard-FileCard-actions {
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: center;
  height: 55px;
  padding: 0 15px;
  background-color: #fafafa;
  border-top: 1px solid #eaeaea;
}
.uppy-size--md .uppy-Dashboard-FileCard-actions {
  height: 65px;
}
[data-uppy-theme=dark] .uppy-Dashboard-FileCard-actions {
  background-color: #1f1f1f;
  border-top: 1px solid #333;
}

[dir="ltr"] .uppy-Dashboard-FileCard-actionsBtn{
  margin-right: 10px;
}

[dir="rtl"] .uppy-Dashboard-FileCard-actionsBtn{
  margin-left: 10px;
}

.uppy-transition-slideDownUp-enter {
  transform: translate3d(0, -105%, 0);
  opacity: 0.01;
  transition: transform 0.25s ease-in-out, opacity 0.25s ease-in-out;
}

.uppy-transition-slideDownUp-enter.uppy-transition-slideDownUp-enter-active {
  transform: translate3d(0, 0, 0);
  opacity: 1;
}

.uppy-transition-slideDownUp-leave {
  transform: translate3d(0, 0, 0);
  opacity: 1;
  transition: transform 0.25s ease-in-out, opacity 0.25s ease-in-out;
}

.uppy-transition-slideDownUp-leave.uppy-transition-slideDownUp-leave-active {
  transform: translate3d(0, -105%, 0);
  opacity: 0.01;
}

@keyframes uppy-Dashboard-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes uppy-Dashboard-fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes uppy-Dashboard-slideDownAndFadeIn {
  from {
    transform: translate3d(-50%, -70%, 0);
    opacity: 0;
  }
  to {
    transform: translate3d(-50%, -50%, 0);
    opacity: 1;
  }
}
@keyframes uppy-Dashboard-slideDownAndFadeIn--small {
  from {
    transform: translate3d(0, -20%, 0);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
@keyframes uppy-Dashboard-slideUpFadeOut {
  from {
    transform: translate3d(-50%, -50%, 0);
    opacity: 1;
  }
  to {
    transform: translate3d(-50%, -70%, 0);
    opacity: 0;
  }
}
@keyframes uppy-Dashboard-slideUpFadeOut--small {
  from {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  to {
    transform: translate3d(0, -20%, 0);
    opacity: 0;
  }
}
.uppy-Dashboard--modal {
  z-index: 1001;
}

.uppy-Dashboard--modal[aria-hidden=true] {
  display: none;
}

.uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose > .uppy-Dashboard-inner {
  animation: uppy-Dashboard-slideDownAndFadeIn--small 0.3s cubic-bezier(0, 0, 0.2, 1);
}
@media only screen and (min-width: 820px) {
  .uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose > .uppy-Dashboard-inner {
    animation: uppy-Dashboard-slideDownAndFadeIn 0.3s cubic-bezier(0, 0, 0.2, 1);
  }
}

.uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose > .uppy-Dashboard-overlay {
  animation: uppy-Dashboard-fadeIn 0.3s cubic-bezier(0, 0, 0.2, 1);
}

.uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose.uppy-Dashboard--isClosing > .uppy-Dashboard-inner {
  animation: uppy-Dashboard-slideUpFadeOut--small 0.3s cubic-bezier(0, 0, 0.2, 1);
}
@media only screen and (min-width: 820px) {
  .uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose.uppy-Dashboard--isClosing > .uppy-Dashboard-inner {
    animation: uppy-Dashboard-slideUpFadeOut 0.3s cubic-bezier(0, 0, 0.2, 1);
  }
}

.uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose.uppy-Dashboard--isClosing > .uppy-Dashboard-overlay {
  animation: uppy-Dashboard-fadeOut 0.3s cubic-bezier(0, 0, 0.2, 1);
}

.uppy-Dashboard-isFixed {
  height: 100vh;
  overflow: hidden;
}

.uppy-Dashboard--modal .uppy-Dashboard-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1001;
  background-color: rgba(0, 0, 0, 0.5);
}

.uppy-Dashboard-inner {
  position: relative;
  max-width: 100%;
  max-height: 100%;
  background-color: #f4f4f4;
  border: 1px solid #eaeaea;
  border-radius: 5px;
  outline: none;
}
.uppy-size--md .uppy-Dashboard-inner {
  min-height: auto;
}
@media only screen and (min-width: 820px) {
  .uppy-Dashboard-inner {
    width: 650px;
    height: 500px;
  }
}
.uppy-Dashboard--modal .uppy-Dashboard-inner {
  z-index: 1002;
}
[data-uppy-theme=dark] .uppy-Dashboard-inner {
  background-color: #1f1f1f;
}
.uppy-Dashboard--isDisabled .uppy-Dashboard-inner {
  cursor: not-allowed;
}

.uppy-Dashboard-innerWrap {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  border-radius: 5px;
  opacity: 0;
}
.uppy-Dashboard--isInnerWrapVisible .uppy-Dashboard-innerWrap {
  opacity: 1;
}
.uppy-Dashboard--isDisabled .uppy-Dashboard-innerWrap {
  opacity: 0.6;
  filter: grayscale(100%);
  -webkit-user-select: none;
          -moz-user-select: none;
       user-select: none;
  cursor: not-allowed;
}

.uppy-Dashboard--isDisabled .uppy-ProviderIconBg {
  fill: #9f9f9f;
}

.uppy-Dashboard--isDisabled [disabled],
.uppy-Dashboard--isDisabled [aria-disabled] {
  pointer-events: none;
  cursor: not-allowed;
}

.uppy-Dashboard--modal .uppy-Dashboard-inner {
  position: fixed;
  top: 35px;
  right: 15px;
  bottom: 15px;
  left: 15px;
  border: none;
}
@media only screen and (min-width: 820px) {
  .uppy-Dashboard--modal .uppy-Dashboard-inner {
    top: 50%;
    right: auto;
    left: 50%;
    box-shadow: 0 5px 15px 4px rgba(0, 0, 0, 0.15);
    transform: translate(-50%, -50%);
  }
}

[dir="ltr"] .uppy-Dashboard-close{
  right: -2px;
}

[dir="rtl"] .uppy-Dashboard-close{
  left: -2px;
}

.uppy-Dashboard-close {
  position: absolute;
  top: -33px;
  z-index: 1005;
  display: block;
  color: rgba(255, 255, 255, 0.9);
  font-size: 27px;
  cursor: pointer;
}
.uppy-Dashboard-close:focus {
  outline: none;
}
.uppy-Dashboard-close::-moz-focus-inner {
  border: 0;
}
.uppy-Dashboard-close:focus {
  color: #6eabf2;
}
@media only screen and (min-width: 820px) {
  [dir="ltr"] .uppy-Dashboard-close{
    right: -35px;
  }
  [dir="rtl"] .uppy-Dashboard-close{
    left: -35px;
  }
  .uppy-Dashboard-close {
    top: -10px;
    font-size: 35px;
  }
}

.uppy-Dashboard-serviceMsg {
  position: relative;
  top: -1px;
  z-index: 1004;
  padding: 12px 0;
  font-weight: 500;
  font-size: 12px;
  line-height: 1.3;
  background-color: #fffbf7;
  border-top: 1px solid #edd4b9;
  border-bottom: 1px solid #edd4b9;
}
.uppy-size--md .uppy-Dashboard-serviceMsg {
  font-size: 14px;
  line-height: 1.4;
}
[data-uppy-theme=dark] .uppy-Dashboard-serviceMsg {
  color: #eaeaea;
  background-color: #1f1f1f;
  border-top: 1px solid #333;
  border-bottom: 1px solid #333;
}

.uppy-Dashboard-serviceMsg-title {
  display: block;
  margin-bottom: 4px;
  padding-left: 42px;
  line-height: 1;
}

.uppy-Dashboard-serviceMsg-text {
  padding: 0 15px;
}

.uppy-Dashboard-serviceMsg-actionBtn {
  color: #1269cf;
  font-weight: inherit;
  font-size: inherit;
  vertical-align: baseline;
  vertical-align: initial;
}
[data-uppy-theme=dark] .uppy-Dashboard-serviceMsg-actionBtn {
  color: rgba(2, 186, 242, 0.9);
}

.uppy-Dashboard-serviceMsg-icon {
  position: absolute;
  top: 10px;
  left: 15px;
}

.uppy-Dashboard-AddFiles {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
}
[data-uppy-drag-drop-supported=true] .uppy-Dashboard-AddFiles {
  height: calc(100% - 14px);
  margin: 7px;
  border: 1px dashed #dfdfdf;
  border-radius: 3px;
}
.uppy-Dashboard-AddFilesPanel .uppy-Dashboard-AddFiles {
  height: calc(100% - 14px - 40px);
  border: none;
}
.uppy-Dashboard--modal .uppy-Dashboard-AddFiles {
  border-color: #cfcfcf;
}
[data-uppy-theme=dark] .uppy-Dashboard-AddFiles {
  border-color: #757575;
}

.uppy-Dashboard-AddFiles-info {
  display: none;
  margin-top: auto;
  padding-top: 15px;
  padding-bottom: 15px;
}
.uppy-size--height-md .uppy-Dashboard-AddFiles-info {
  display: block;
}
.uppy-size--md .uppy-Dashboard-AddFiles-info {
  position: absolute;
  right: 0;
  bottom: 25px;
  left: 0;
  padding-top: 30px;
  padding-bottom: 0;
}
[data-uppy-num-acquirers="0"] .uppy-Dashboard-AddFiles-info {
  margin-top: 0;
}

.uppy-Dashboard-browse {
  color: #1269cf;
  cursor: pointer;
}
.uppy-Dashboard-browse:focus {
  outline: none;
}
.uppy-Dashboard-browse::-moz-focus-inner {
  border: 0;
}
.uppy-Dashboard-browse:hover, .uppy-Dashboard-browse:focus {
  border-bottom: 1px solid #1269cf;
}
[data-uppy-theme=dark] .uppy-Dashboard-browse {
  color: rgba(2, 186, 242, 0.9);
}
[data-uppy-theme=dark] .uppy-Dashboard-browse:hover, [data-uppy-theme=dark] .uppy-Dashboard-browse:focus {
  border-bottom: 1px solid #02baf2;
}

.uppy-Dashboard-browseBtn {
  display: block;
  width: 100%;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: 500;
  font-size: 14px;
}
.uppy-size--md .uppy-Dashboard-browseBtn {
  width: auto;
  margin: auto;
  margin-top: 15px;
  margin-bottom: 15px;
  padding: 13px 44px;
  font-size: 15px;
}

.uppy-Dashboard-AddFiles-list {
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  margin-top: 2px;
  padding: 2px 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.uppy-size--md .uppy-Dashboard-AddFiles-list {
  flex: none;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 600px;
  margin-top: 15px;
  padding-top: 0;
  overflow-y: visible;
}

.uppy-DashboardTab {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #eaeaea;
}
[data-uppy-theme=dark] .uppy-DashboardTab {
  border-bottom: 1px solid #333;
}
.uppy-size--md .uppy-DashboardTab {
  display: inline-block;
  width: auto;
  width: initial;
  margin-bottom: 10px;
  border-bottom: none;
}

.uppy-DashboardTab-btn {
  flex-direction: row;
  align-items: center;
  justify-content: left;
  width: 100%;
  height: 100%;
  padding: 12px 15px;
  color: #525252;
  background-color: transparent;
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
       appearance: none;
}
.uppy-DashboardTab-btn:focus {
  outline: none;
}
.uppy-DashboardTab-btn::-moz-focus-inner {
  border: 0;
}
[dir="ltr"] .uppy-size--md .uppy-DashboardTab-btn{
  margin-right: 1px;
}
[dir="rtl"] .uppy-size--md .uppy-DashboardTab-btn{
  margin-left: 1px;
}
.uppy-size--md .uppy-DashboardTab-btn {
  flex-direction: column;
  width: 86px;
  padding: 10px 3px;
  border-radius: 5px;
}
[data-uppy-theme=dark] .uppy-DashboardTab-btn {
  color: #eaeaea;
}

.uppy-DashboardTab-btn::-moz-focus-inner {
  border: 0;
}

.uppy-DashboardTab-btn:hover {
  background-color: #e9ecef;
}
[data-uppy-theme=dark] .uppy-DashboardTab-btn:hover {
  background-color: #333;
}

.uppy-DashboardTab-btn:active,
.uppy-DashboardTab-btn:focus {
  background-color: #dfe6f1;
}
[data-uppy-theme=dark] .uppy-DashboardTab-btn:active,
[data-uppy-theme=dark] .uppy-DashboardTab-btn:focus {
  background-color: #525252;
}

.uppy-DashboardTab-btn svg {
  display: inline-block;
  max-width: 100%;
  max-height: 100%;
  overflow: hidden;
  vertical-align: text-top;
  transition: transform ease-in-out 0.15s;
}

[dir="ltr"] .uppy-DashboardTab-inner{
  margin-right: 10px;
}

[dir="rtl"] .uppy-DashboardTab-inner{
  margin-left: 10px;
}

.uppy-DashboardTab-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.1), 0 2px 3px 0 rgba(0, 0, 0, 0.02);
}
[dir="ltr"] .uppy-size--md .uppy-DashboardTab-inner{
  margin-right: 0;
}
[dir="rtl"] .uppy-size--md .uppy-DashboardTab-inner{
  margin-left: 0;
}
[data-uppy-theme=dark] .uppy-DashboardTab-inner {
  background-color: #323232;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2), 0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 2px 3px 0 rgba(0, 0, 0, 0.08);
}

.uppy-DashboardTab-name {
  font-weight: 400;
  font-size: 14px;
}
.uppy-size--md .uppy-DashboardTab-name {
  margin-top: 8px;
  margin-bottom: 0;
  font-size: 12px;
  line-height: 15px;
}

.uppy-DashboardTab-iconMyDevice {
  color: #1269cf;
}
[data-uppy-theme=dark] .uppy-DashboardTab-iconMyDevice {
  color: #02baf2;
}

.uppy-DashboardTab-iconBox {
  color: #0061d5;
}
[data-uppy-theme=dark] .uppy-DashboardTab-iconBox {
  color: #eaeaea;
}

.uppy-DashboardTab-iconDropbox {
  color: #0061fe;
}
[data-uppy-theme=dark] .uppy-DashboardTab-iconDropbox {
  color: #eaeaea;
}

.uppy-DashboardTab-iconUnsplash {
  color: #111;
}
[data-uppy-theme=dark] .uppy-DashboardTab-iconUnsplash {
  color: #eaeaea;
}

.uppy-DashboardTab-iconWebdav {
  color: #111;
}
[data-uppy-theme=dark] .uppy-DashboardTab-iconWebdav {
  color: #eaeaea;
}

.uppy-DashboardTab-iconScreenRec {
  color: #2c3e50;
}
[data-uppy-theme=dark] .uppy-DashboardTab-iconScreenRec {
  color: #eaeaea;
}

.uppy-DashboardTab-iconAudio {
  color: #8030a3;
}
[data-uppy-theme=dark] .uppy-DashboardTab-iconAudio {
  color: #bf6ee3;
}

.uppy-Dashboard-input {
  position: absolute;
  z-index: -1;
  width: 0.1px;
  height: 0.1px;
  overflow: hidden;
  opacity: 0;
}

.uppy-DashboardContent-bar {
  position: relative;
  z-index: 1004;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 40px;
  padding: 0 10px;
  background-color: #fafafa;
  border-bottom: 1px solid #eaeaea;
}
.uppy-size--md .uppy-DashboardContent-bar {
  height: 50px;
  padding: 0 15px;
}
[data-uppy-theme=dark] .uppy-DashboardContent-bar {
  background-color: #1f1f1f;
  border-bottom: 1px solid #333;
}

.uppy-DashboardContent-title {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  max-width: 170px;
  margin: auto;
  overflow-x: hidden;
  font-weight: 500;
  font-size: 12px;
  line-height: 40px;
  white-space: nowrap;
  text-align: center;
  text-overflow: ellipsis;
}
.uppy-size--md .uppy-DashboardContent-title {
  max-width: 300px;
  font-size: 14px;
  line-height: 50px;
}
[data-uppy-theme=dark] .uppy-DashboardContent-title {
  color: #eaeaea;
}

[dir="ltr"] .uppy-DashboardContent-back,[dir="ltr"] 
.uppy-DashboardContent-save{
  margin-left: -6px;
}

[dir="rtl"] .uppy-DashboardContent-back,[dir="rtl"] 
.uppy-DashboardContent-save{
  margin-right: -6px;
}

.uppy-DashboardContent-back,
.uppy-DashboardContent-save {
  margin: 0;
  padding: 0;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: 1;
  background: none;
  border: 0;
  -webkit-appearance: none;
  padding: 7px 6px;
  color: #1269cf;
  font-weight: 400;
  font-size: 12px;
  border-radius: 3px;
  cursor: pointer;
}
.uppy-DashboardContent-back:focus,
.uppy-DashboardContent-save:focus {
  outline: none;
}
.uppy-DashboardContent-back::-moz-focus-inner,
.uppy-DashboardContent-save::-moz-focus-inner {
  border: 0;
}
.uppy-DashboardContent-back:hover,
.uppy-DashboardContent-save:hover {
  color: #0e51a0;
}
.uppy-DashboardContent-back:focus,
.uppy-DashboardContent-save:focus {
  background-color: #dfe6f1;
}
[data-uppy-theme=dark] .uppy-DashboardContent-back:focus,
[data-uppy-theme=dark] .uppy-DashboardContent-save:focus {
  background-color: #333;
}
.uppy-size--md .uppy-DashboardContent-back,
.uppy-size--md .uppy-DashboardContent-save {
  font-size: 14px;
}
[data-uppy-theme=dark] .uppy-DashboardContent-back,
[data-uppy-theme=dark] .uppy-DashboardContent-save {
  color: #02baf2;
}

[dir="ltr"] .uppy-DashboardContent-addMore{
  margin-right: -5px;
}

[dir="rtl"] .uppy-DashboardContent-addMore{
  margin-left: -5px;
}

.uppy-DashboardContent-addMore {
  margin: 0;
  padding: 0;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: 1;
  background: none;
  border: 0;
  -webkit-appearance: none;
  width: 29px;
  height: 29px;
  padding: 7px 8px;
  color: #1269cf;
  font-weight: 500;
  border-radius: 3px;
  cursor: pointer;
}
.uppy-DashboardContent-addMore:focus {
  outline: none;
}
.uppy-DashboardContent-addMore::-moz-focus-inner {
  border: 0;
}
.uppy-DashboardContent-addMore:hover {
  color: #0e51a0;
}
.uppy-DashboardContent-addMore:focus {
  background-color: #dfe6f1;
}
[data-uppy-theme=dark] .uppy-DashboardContent-addMore:focus {
  background-color: #333;
}
[dir="ltr"] .uppy-size--md .uppy-DashboardContent-addMore{
  margin-right: -8px;
}
[dir="rtl"] .uppy-size--md .uppy-DashboardContent-addMore{
  margin-left: -8px;
}
.uppy-size--md .uppy-DashboardContent-addMore {
  width: auto;
  height: auto;
  font-size: 14px;
}
[data-uppy-theme=dark] .uppy-DashboardContent-addMore {
  color: #02baf2;
}

[dir="ltr"] .uppy-DashboardContent-addMore svg{
  margin-right: 4px;
}

[dir="rtl"] .uppy-DashboardContent-addMore svg{
  margin-left: 4px;
}

.uppy-DashboardContent-addMore svg {
  vertical-align: baseline;
}
.uppy-size--md .uppy-DashboardContent-addMore svg {
  width: 11px;
  height: 11px;
}

.uppy-DashboardContent-addMoreCaption {
  display: none;
}
.uppy-size--md .uppy-DashboardContent-addMoreCaption {
  display: inline;
}

.uppy-DashboardContent-panel {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1005;
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
  background-color: whitesmoke;
  border-radius: 5px;
}

.uppy-Dashboard-AddFilesPanel {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1005;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fafafa;
  background: linear-gradient(0deg, #fafafa 35%, rgba(250, 250, 250, 0.85) 100%);
  border-radius: 5px;
  box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.15);
}
[data-uppy-theme=dark] .uppy-Dashboard-AddFilesPanel {
  background-color: #333;
  background-image: linear-gradient(0deg, #1f1f1f 35%, rgba(31, 31, 31, 0.85) 100%);
}

.uppy-Dashboard--isAddFilesPanelVisible .uppy-Dashboard-files {
  filter: blur(2px);
}

.uppy-Dashboard-progress {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 12%;
}

.uppy-Dashboard-progressBarContainer.is-active {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1004;
  width: 100%;
  height: 100%;
}

.uppy-Dashboard-filesContainer {
  position: relative;
  flex: 1;
  margin: 0;
  overflow-y: hidden;
}
.uppy-Dashboard-filesContainer::after {
  display: table;
  clear: both;
  content: "";
}

.uppy-Dashboard-files {
  flex: 1;
  margin: 0;
  padding: 0 0 10px 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.uppy-size--md .uppy-Dashboard-files {
  padding-top: 10px;
}

.uppy-Dashboard--singleFile .uppy-Dashboard-filesInner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.uppy-Dashboard-dropFilesHereHint {
  position: absolute;
  top: 7px;
  right: 7px;
  bottom: 7px;
  left: 7px;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 90px;
  color: #757575;
  font-size: 16px;
  text-align: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-repeat: no-repeat;
  background-position: 50% 50%;
  border: 1px dashed #1269cf;
  border-radius: 3px;
  visibility: hidden;
}
[data-uppy-theme=dark] .uppy-Dashboard-dropFilesHereHint {
  color: #bbb;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  border-color: #02baf2;
}

.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-Dashboard-dropFilesHereHint {
  visibility: visible;
  pointer-events: none;
}
.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-DashboardContent-bar,
.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-Dashboard-files,
.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-Dashboard-progressindicators,
.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-Dashboard-serviceMsg {
  opacity: 0.15;
}
.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-Dashboard-AddFiles {
  opacity: 0.03;
}

.uppy-Dashboard-AddFiles-title {
  width: 100%;
  margin-top: 15px;
  margin-bottom: 5px;
  padding: 0 15px;
  color: #000;
  font-weight: 500;
  font-size: 17px;
  line-height: 1.35;
  text-align: inline-start;
}
.uppy-size--md .uppy-Dashboard-AddFiles-title {
  max-width: 480px;
  padding: 0 35px;
  margin-top: 5px;
  font-weight: 400;
  font-size: 21px;
  text-align: center;
}
[data-uppy-num-acquirers="0"] .uppy-Dashboard-AddFiles-title {
  text-align: center;
}
[data-uppy-theme=dark] .uppy-Dashboard-AddFiles-title {
  color: #eaeaea;
}
.uppy-Dashboard-AddFiles-title button {
  font-weight: 500;
}
.uppy-size--md .uppy-Dashboard-AddFiles-title button {
  font-weight: 400;
}

.uppy-Dashboard-note {
  max-width: 350px;
  margin: auto;
  padding: 0 15px;
  color: #757575;
  font-size: 14px;
  line-height: 1.25;
  text-align: center;
}
.uppy-size--md .uppy-Dashboard-note {
  max-width: 600px;
  line-height: 1.35;
}
[data-uppy-theme=dark] .uppy-Dashboard-note {
  color: #cfcfcf;
}

a.uppy-Dashboard-poweredBy {
  display: inline-block;
  margin-top: 8px;
  color: #939393;
  font-size: 11px;
  text-align: center;
  -webkit-text-decoration: none;
  text-decoration: none;
}

.uppy-Dashboard-poweredByIcon {
  position: relative;
  top: 1px;
  margin-right: 1px;
  margin-left: 1px;
  vertical-align: text-top;
  opacity: 0.9;
  fill: none;
  stroke: #939393;
}

.uppy-Dashboard-Item-previewIcon {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 100;
  width: 25px;
  height: 25px;
  transform: translate(-50%, -50%);
}
.uppy-size--md .uppy-Dashboard-Item-previewIcon {
  width: 38px;
  height: 38px;
}
.uppy-Dashboard-Item-previewIcon svg {
  width: 100%;
  height: 100%;
}
.uppy-Dashboard--singleFile .uppy-Dashboard-Item-previewIcon {
  width: 100%;
  height: 100%;
  max-width: 60%;
  max-height: 60%;
}

.uppy-Dashboard-Item-previewIconWrap {
  position: relative;
  height: 76px;
  max-height: 75%;
}
.uppy-Dashboard--singleFile .uppy-Dashboard-Item-previewIconWrap {
  width: 100%;
  height: 100%;
}

.uppy-Dashboard-Item-previewIconBg {
  width: 100%;
  height: 100%;
  filter: drop-shadow(rgba(0, 0, 0, 0.1) 0 1px 1px);
}

.uppy-Dashboard-upload {
  position: relative;
  width: 50px;
  height: 50px;
}
.uppy-size--md .uppy-Dashboard-upload {
  width: 60px;
  height: 60px;
}

.uppy-Dashboard-upload .uppy-c-icon {
  position: relative;
  top: 1px;
  width: 50%;
}

[dir="ltr"] .uppy-Dashboard-uploadCount{
  right: -12px;
}

[dir="rtl"] .uppy-Dashboard-uploadCount{
  left: -12px;
}

.uppy-Dashboard-uploadCount {
  position: absolute;
  top: -12px;
  width: 16px;
  height: 16px;
  color: #fff;
  font-size: 8px;
  line-height: 16px;
  background-color: #1bb240;
  border-radius: 50%;
}
.uppy-size--md .uppy-Dashboard-uploadCount {
  width: 18px;
  height: 18px;
  font-size: 9px;
  line-height: 18px;
}`, "",{"version":3,"sources":["webpack://./node_modules/@uppy/dashboard/dist/style.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,OAAO;EACP,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;sEAasE;AACtE;;mDAEmD;AACnD;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,+BAA+B;EAC/B,qBAAqB;EAErB,2BAA2B;EAC3B,UAAU;EACV,oCAA8I;EAA9I,8IAA8I;EAC9I,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,mBAAgD;EAAhD,gDAAgD;EAChD,eAA0C;EAA1C,0CAA0C;EAC1C,mBAAmB;EACnB,oBAAoD;EAApD,oDAAoD;EACpD,iCAAiC;EACjC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;;;EAIE,UAAU;EACV,oBAAoB;AACtB;;AAEA;;mDAEmD;AACnD;EACE,YAAY;EACZ,SAAS;EACT,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,6DAA8a;EAC9a,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;mDAEmD;AACnD;EACE,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;;mDAEmD;AACnD;EACE,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;mDAEmD;AACnD;EACE,SAAS;EACT,YAAY;EACZ,SAAS;EACT,WAAW;EACX,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,6DAAyb;EACzb,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;mDAEmD;AACnD;EACE,SAAS;EACT,oDAAoD;AACtD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;mDAEmD;AACnD;EACE,SAAS;EACT,iDAAiD;AACnD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;;mDAEmD;AACnD;;EAEE,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,6DAA0b;AAC5b;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;mDAEmD;AACnD;;EAEE,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,6DAAub;AACzb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;mDAEmD;AACnD;EACE,WAAW;EACX,mBAAoB;EAApB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAoB;EAApB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAoB;EAApB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,iDAAiD;AACnD;AACA;EACE,gLAAgL;EAChL,0BAA0B;EAC1B,4DAA4D;AAC9D;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,+CAA+C;AACjD;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,+CAA+C;AACjD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,+CAA+C;AACjD;AACA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;UAChB,qBAAgB;OAAhB,gBAAgB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+CAA+C;EAC/C,sBAAsB;EACtB,iCAAiC;EACjC,mCAAmC;EACnC,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;AACd;AACA;;EAEE,UAAU;EACV,WAAW;AACb;AACA;;EAEE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;AACA;;;;EAIE,aAAa;AACf;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,0CAA0C;AAC5C;AACA;;EAEE,0CAA0C;AAC5C;AACA;;EAEE,UAAU;EACV,WAAW;EACX,wBAAwB;AAC1B;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;EACT,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE;;IAEE,cAAc;EAChB;AACF;AACA;;EAEE,8CAA8C;AAChD;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,oBAAiB;KAAjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,OAAO;EACP,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,YAAY;EACZ,6BAAqB;EAArB,qBAAqB;AACvB;AACA;;EAEE,8BAA8B;EAC9B,kCAA0B;EAA1B,0BAA0B;AAC5B;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,SAAS;AACX;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,QAAQ;EACR,WAAW;EACX,WAAW;AACb;AACA;;EAEE,UAAU;AACZ;AACA;;;;EAIE,cAAc;AAChB;AACA;;EAEE,6CAA6C;AAC/C;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,8CAA8C;AAChD;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,UAAU;AACZ;AACA;EACE,oCAAoC;EACpC,4CAA4C;AAC9C;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gPAAqK;EACrK,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kCAA0B;EAA1B,0BAA0B;EAC1B,aAAa;AACf;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,6CAA6C;AAC/C;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kCAA0B;EAA1B,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gPAAqK;EACrK,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAHA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kCAA0B;EAA1B,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,cAAc;EACd,OAAO;EACP,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,iCAAiC;AACnC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,8BAA8B;IAC9B,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;AACF;AACA,iDAAiD;AACjD;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;AACf;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAiB;KAAjB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,sBAAmB;KAAnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;;EAEE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAa;EAAb,aAAa;AACf;;AAEA;EACE,WAAc;EAAd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAA0B;EAA1B,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,+CAA+C;AACjD;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,4FAA4F;EAC5F,kCAAkC;EAClC,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,4FAA4F;EAC5F,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,4FAA4F;EAC5F,8BAA8B;EAC9B,aAAa;EACb,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,yDAA2qB;EAC3qB,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB;EACrB,YAAY;EACZ,WAAW;AACb;AACA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;AACA;EACE,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,uBAAuB;EACvB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,cAAc;EACd,WAAW;EACX,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,wBAAwB;UAChB,qBAAgB;OAAhB,gBAAgB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;AAC7C;AACA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,oBAAiB;KAAjB,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,kEAAkE;AACpE;;AAEA;EACE,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,UAAU;EACV,kEAAkE;AACpE;;AAEA;EACE,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,qCAAqC;IACrC,UAAU;EACZ;EACA;IACE,qCAAqC;IACrC,UAAU;EACZ;AACF;AACA;EACE;IACE,kCAAkC;IAClC,UAAU;EACZ;EACA;IACE,+BAA+B;IAC/B,UAAU;EACZ;AACF;AACA;EACE;IACE,qCAAqC;IACrC,UAAU;EACZ;EACA;IACE,qCAAqC;IACrC,UAAU;EACZ;AACF;AACA;EACE;IACE,+BAA+B;IAC/B,UAAU;EACZ;EACA;IACE,kCAAkC;IAClC,UAAU;EACZ;AACF;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mFAAmF;AACrF;AACA;EACE;IACE,4EAA4E;EAC9E;AACF;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,+EAA+E;AACjF;AACA;EACE;IACE,wEAAwE;EAC1E;AACF;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;UACjB,sBAAiB;OAAjB,iBAAiB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;AACd;AACA;EACE;IACE,QAAQ;IACR,WAAW;IACX,SAAS;IACT,8CAA8C;IAC9C,gCAAgC;EAClC;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,wBAAuB;EAAvB,uBAAuB;AACzB;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,OAAO;EACP,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,WAAc;EAAd,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,wBAAwB;EACxB,qBAAgB;OAAhB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,2GAA2G;AAC7G;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,2GAA2G;AAC7G;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,SAAS;AACX;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,sBAAsB;AACxB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,8EAA8E;EAC9E,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE,sBAAsB;EACtB,iFAAiF;AACnF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,OAAO;EACP,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;EACT,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,yDAAsd;EACtd,4BAA4B;EAC5B,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,yDAAsd;EACtd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;;;EAIE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,6BAAqB;EAArB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB","sourcesContent":["@charset \"UTF-8\";\n.uppy-Informer {\n  position: absolute;\n  right: 0;\n  bottom: 60px;\n  left: 0;\n  z-index: 1005;\n  text-align: center;\n}\n.uppy-Informer span > div {\n  margin-bottom: 6px;\n}\n\n.uppy-Informer-animated {\n  z-index: -1000;\n  transform: translateY(350%);\n  opacity: 0;\n  transition: all 300ms ease-in;\n}\n\n.uppy-Informer p {\n  display: inline-block;\n  max-width: 90%;\n  margin: 0;\n  padding: 0;\n  padding: 6px 15px;\n  color: #fff;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 1.4;\n  background-color: #757575;\n  border-radius: 18px;\n}\n.uppy-size--md .uppy-Informer p {\n  max-width: 500px;\n  padding: 10px 20px;\n  font-size: 14px;\n  line-height: 1.3;\n}\n[data-uppy-theme=dark] .uppy-Informer p {\n  background-color: #333;\n}\n\n[dir=\"ltr\"] .uppy-Informer p span{\n  left: 3px;\n}\n\n[dir=\"rtl\"] .uppy-Informer p span{\n  right: 3px;\n}\n\n[dir=\"ltr\"] .uppy-Informer p span{\n  margin-left: -1px;\n}\n\n[dir=\"rtl\"] .uppy-Informer p span{\n  margin-right: -1px;\n}\n\n.uppy-Informer p span {\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 13px;\n  height: 13px;\n  color: #525252;\n  font-size: 10px;\n  line-height: 12px;\n  vertical-align: middle;\n  background-color: #fff;\n  border-radius: 50%;\n}\n\n.uppy-Informer p span:hover {\n  cursor: help;\n}\n\n.uppy-Informer p span::after {\n  line-height: 1.3;\n  word-wrap: break-word;\n}\n\n/* -------------------------------------------------------------------\n  Microtip\n\n  Modern, lightweight css-only tooltips\n  Just 1kb minified and gzipped\n\n  @author Ghosh\n  @package Microtip\n\n----------------------------------------------------------------------\n  1. Base Styles\n  2. Direction Modifiers\n  3. Position Modifiers\n-------------------------------------------------------------------- */\n/* ------------------------------------------------\n  [1] Base Styles\n------------------------------------------------- */\n.uppy-Root [aria-label][role~=tooltip] {\n  position: relative;\n}\n\n.uppy-Root [aria-label][role~=tooltip]::before,\n.uppy-Root [aria-label][role~=tooltip]::after {\n  position: absolute;\n  z-index: 10;\n  box-sizing: border-box;\n  transform: translate3d(0, 0, 0);\n  transform-origin: top;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  opacity: 0;\n  transition: all var(--microtip-transition-duration, 0.18s) var(--microtip-transition-easing, ease-in-out) var(--microtip-transition-delay, 0s);\n  pointer-events: none;\n  will-change: transform;\n}\n\n.uppy-Root [aria-label][role~=tooltip]::before {\n  background-size: 100% auto !important;\n  content: \"\";\n}\n\n.uppy-Root [aria-label][role~=tooltip]::after {\n  box-sizing: content-box;\n  padding: 0.5em 1em;\n  color: #fff;\n  font-weight: var(--microtip-font-weight, normal);\n  font-size: var(--microtip-font-size, 13px);\n  white-space: nowrap;\n  text-transform: var(--microtip-text-transform, none);\n  background: rgba(17, 17, 17, 0.9);\n  border-radius: 4px;\n  content: attr(aria-label);\n}\n\n.uppy-Root [aria-label][role~=tooltip]:hover::before,\n.uppy-Root [aria-label][role~=tooltip]:hover::after,\n.uppy-Root [aria-label][role~=tooltip]:focus::before,\n.uppy-Root [aria-label][role~=tooltip]:focus::after {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n/* ------------------------------------------------\n  [2] Position Modifiers\n------------------------------------------------- */\n.uppy-Root [role~=tooltip][data-microtip-position|=top]::before {\n  bottom: 100%;\n  left: 50%;\n  width: 18px;\n  height: 6px;\n  margin-bottom: 5px;\n  background: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2236px%22%20height%3D%2212px%22%3E%3Cpath%20fill%3D%22rgba%2817,%2017,%2017,%200.9%29%22%20transform%3D%22rotate%280%29%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E\") no-repeat;\n  transform: translate3d(-50%, 0, 0);\n}\n\n.uppy-Root [role~=tooltip][data-microtip-position|=top]::after {\n  bottom: 100%;\n  left: 50%;\n  margin-bottom: 11px;\n  transform: translate3d(-50%, 0, 0);\n}\n\n.uppy-Root [role~=tooltip][data-microtip-position|=top]:hover::before {\n  transform: translate3d(-50%, -5px, 0);\n}\n\n.uppy-Root [role~=tooltip][data-microtip-position=top]:hover::after {\n  transform: translate3d(-50%, -5px, 0);\n}\n\n/* ------------------------------------------------\n  [2.1] Top Left\n------------------------------------------------- */\n.uppy-Root [role~=tooltip][data-microtip-position=top-left]::after {\n  bottom: 100%;\n  transform: translate3d(calc(-100% + 16px), 0, 0);\n}\n\n.uppy-Root [role~=tooltip][data-microtip-position=top-left]:hover::after {\n  transform: translate3d(calc(-100% + 16px), -5px, 0);\n}\n\n/* ------------------------------------------------\n  [2.2] Top Right\n------------------------------------------------- */\n.uppy-Root [role~=tooltip][data-microtip-position=top-right]::after {\n  bottom: 100%;\n  transform: translate3d(calc(0% - 16px), 0, 0);\n}\n\n.uppy-Root [role~=tooltip][data-microtip-position=top-right]:hover::after {\n  transform: translate3d(calc(0% - 16px), -5px, 0);\n}\n\n/* ------------------------------------------------\n  [2.3] Bottom\n------------------------------------------------- */\n.uppy-Root [role~=tooltip][data-microtip-position|=bottom]::before {\n  top: 100%;\n  bottom: auto;\n  left: 50%;\n  width: 18px;\n  height: 6px;\n  margin-top: 5px;\n  margin-bottom: 0;\n  background: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2236px%22%20height%3D%2212px%22%3E%3Cpath%20fill%3D%22rgba%2817,%2017,%2017,%200.9%29%22%20transform%3D%22rotate%28180%2018%206%29%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E\") no-repeat;\n  transform: translate3d(-50%, -10px, 0);\n}\n\n.uppy-Root [role~=tooltip][data-microtip-position|=bottom]::after {\n  top: 100%;\n  left: 50%;\n  margin-top: 11px;\n  transform: translate3d(-50%, -10px, 0);\n}\n\n.uppy-Root [role~=tooltip][data-microtip-position|=bottom]:hover::before {\n  transform: translate3d(-50%, 0, 0);\n}\n\n.uppy-Root [role~=tooltip][data-microtip-position=bottom]:hover::after {\n  transform: translate3d(-50%, 0, 0);\n}\n\n/* ------------------------------------------------\n  [2.4] Bottom Left\n------------------------------------------------- */\n.uppy-Root [role~=tooltip][data-microtip-position=bottom-left]::after {\n  top: 100%;\n  transform: translate3d(calc(-100% + 16px), -10px, 0);\n}\n\n.uppy-Root [role~=tooltip][data-microtip-position=bottom-left]:hover::after {\n  transform: translate3d(calc(-100% + 16px), 0, 0);\n}\n\n/* ------------------------------------------------\n  [2.5] Bottom Right\n------------------------------------------------- */\n.uppy-Root [role~=tooltip][data-microtip-position=bottom-right]::after {\n  top: 100%;\n  transform: translate3d(calc(0% - 16px), -10px, 0);\n}\n\n.uppy-Root [role~=tooltip][data-microtip-position=bottom-right]:hover::after {\n  transform: translate3d(calc(0% - 16px), 0, 0);\n}\n\n/* ------------------------------------------------\n  [2.6] Left\n------------------------------------------------- */\n.uppy-Root [role~=tooltip][data-microtip-position=left]::before,\n.uppy-Root [role~=tooltip][data-microtip-position=left]::after {\n  top: 50%;\n  right: 100%;\n  bottom: auto;\n  left: auto;\n  transform: translate3d(10px, -50%, 0);\n}\n\n.uppy-Root [role~=tooltip][data-microtip-position=left]::before {\n  width: 6px;\n  height: 18px;\n  margin-right: 5px;\n  margin-bottom: 0;\n  background: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2212px%22%20height%3D%2236px%22%3E%3Cpath%20fill%3D%22rgba%2817,%2017,%2017,%200.9%29%22%20transform%3D%22rotate%28-90%2018%2018%29%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E\") no-repeat;\n}\n\n.uppy-Root [role~=tooltip][data-microtip-position=left]::after {\n  margin-right: 11px;\n}\n\n.uppy-Root [role~=tooltip][data-microtip-position=left]:hover::before,\n.uppy-Root [role~=tooltip][data-microtip-position=left]:hover::after {\n  transform: translate3d(0, -50%, 0);\n}\n\n/* ------------------------------------------------\n  [2.7] Right\n------------------------------------------------- */\n.uppy-Root [role~=tooltip][data-microtip-position=right]::before,\n.uppy-Root [role~=tooltip][data-microtip-position=right]::after {\n  top: 50%;\n  bottom: auto;\n  left: 100%;\n  transform: translate3d(-10px, -50%, 0);\n}\n\n.uppy-Root [role~=tooltip][data-microtip-position=right]::before {\n  width: 6px;\n  height: 18px;\n  margin-bottom: 0;\n  margin-left: 5px;\n  background: url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2212px%22%20height%3D%2236px%22%3E%3Cpath%20fill%3D%22rgba%2817,%2017,%2017,%200.9%29%22%20transform%3D%22rotate%2890%206%206%29%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E\") no-repeat;\n}\n\n.uppy-Root [role~=tooltip][data-microtip-position=right]::after {\n  margin-left: 11px;\n}\n\n.uppy-Root [role~=tooltip][data-microtip-position=right]:hover::before,\n.uppy-Root [role~=tooltip][data-microtip-position=right]:hover::after {\n  transform: translate3d(0, -50%, 0);\n}\n\n/* ------------------------------------------------\n  [3] Size\n------------------------------------------------- */\n.uppy-Root [role~=tooltip][data-microtip-size=small]::after {\n  width: 80px;\n  white-space: initial;\n}\n\n.uppy-Root [role~=tooltip][data-microtip-size=medium]::after {\n  width: 150px;\n  white-space: initial;\n}\n\n.uppy-Root [role~=tooltip][data-microtip-size=large]::after {\n  width: 260px;\n  white-space: initial;\n}\n\n.uppy-StatusBar {\n  position: relative;\n  z-index: 1001;\n  display: flex;\n  height: 46px;\n  color: #fff;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 40px;\n  background-color: #fff;\n  transition: height 0.2s;\n}\n[data-uppy-theme=dark] .uppy-StatusBar {\n  background-color: #1f1f1f;\n}\n\n.uppy-StatusBar::before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background-color: #eaeaea;\n  content: \"\";\n}\n[data-uppy-theme=dark] .uppy-StatusBar::before {\n  background-color: #757575;\n}\n\n.uppy-StatusBar[aria-hidden=true] {\n  height: 0;\n  overflow-y: hidden;\n}\n\n.uppy-StatusBar.is-complete .uppy-StatusBar-progress {\n  background-color: #1bb240;\n}\n\n.uppy-StatusBar.is-error .uppy-StatusBar-progress {\n  background-color: #e32437;\n}\n\n.uppy-StatusBar.is-complete .uppy-StatusBar-statusIndicator {\n  color: #1bb240;\n}\n\n.uppy-StatusBar.is-error .uppy-StatusBar-statusIndicator {\n  color: #e32437;\n}\n\n.uppy-StatusBar:not([aria-hidden=true]).is-waiting {\n  height: 65px;\n  background-color: #fff;\n  border-top: 1px solid #eaeaea;\n}\n[data-uppy-theme=dark] .uppy-StatusBar:not([aria-hidden=true]).is-waiting {\n  background-color: #1f1f1f;\n  border-top: 1px solid #333;\n}\n\n.uppy-StatusBar-progress {\n  position: absolute;\n  z-index: 1001;\n  height: 2px;\n  background-color: #1269cf;\n  transition: background-color, width 0.3s ease-out;\n}\n.uppy-StatusBar-progress.is-indeterminate {\n  background-image: linear-gradient(45deg, rgba(0, 0, 0, 0.3) 25%, transparent 25%, transparent 50%, rgba(0, 0, 0, 0.3) 50%, rgba(0, 0, 0, 0.3) 75%, transparent 75%, transparent);\n  background-size: 64px 64px;\n  animation: uppy-StatusBar-ProgressStripes 1s linear infinite;\n}\n\n@keyframes uppy-StatusBar-ProgressStripes {\n  from {\n    background-position: 0 0;\n  }\n  to {\n    background-position: 64px 0;\n  }\n}\n.uppy-StatusBar.is-preprocessing .uppy-StatusBar-progress,\n.uppy-StatusBar.is-postprocessing .uppy-StatusBar-progress {\n  background-color: #f6a623;\n}\n\n.uppy-StatusBar.is-waiting .uppy-StatusBar-progress {\n  display: none;\n}\n\n[dir=\"ltr\"] .uppy-StatusBar-content{\n  padding-left: 10px;\n}\n\n[dir=\"rtl\"] .uppy-StatusBar-content{\n  padding-right: 10px;\n}\n\n.uppy-StatusBar-content {\n  position: relative;\n  z-index: 1002;\n  display: flex;\n  align-items: center;\n  height: 100%;\n  color: #333;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n[dir=\"ltr\"] .uppy-size--md .uppy-StatusBar-content{\n  padding-left: 15px;\n}\n[dir=\"rtl\"] .uppy-size--md .uppy-StatusBar-content{\n  padding-right: 15px;\n}\n[data-uppy-theme=dark] .uppy-StatusBar-content {\n  color: #eaeaea;\n}\n\n[dir=\"ltr\"] .uppy-StatusBar-status{\n  padding-right: 0.3em;\n}\n\n[dir=\"rtl\"] .uppy-StatusBar-status{\n  padding-left: 0.3em;\n}\n\n.uppy-StatusBar-status {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  font-weight: normal;\n  line-height: 1.4;\n}\n\n.uppy-StatusBar-statusPrimary {\n  font-weight: 500;\n  line-height: 1;\n  display: flex;\n}\n.uppy-StatusBar-statusPrimary button.uppy-StatusBar-details {\n  margin-left: 5px;\n}\n[data-uppy-theme=dark] .uppy-StatusBar-statusPrimary {\n  color: #eaeaea;\n}\n\n.uppy-StatusBar-statusSecondary {\n  display: inline-block;\n  margin-top: 1px;\n  color: #757575;\n  font-size: 11px;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n[data-uppy-theme=dark] .uppy-StatusBar-statusSecondary {\n  color: #bbb;\n}\n\n[dir=\"ltr\"] .uppy-StatusBar-statusSecondaryHint{\n  margin-right: 5px;\n}\n\n[dir=\"rtl\"] .uppy-StatusBar-statusSecondaryHint{\n  margin-left: 5px;\n}\n\n.uppy-StatusBar-statusSecondaryHint {\n  display: inline-block;\n  line-height: 1;\n  vertical-align: middle;\n}\n[dir=\"ltr\"] .uppy-size--md .uppy-StatusBar-statusSecondaryHint{\n  margin-right: 8px;\n}\n[dir=\"rtl\"] .uppy-size--md .uppy-StatusBar-statusSecondaryHint{\n  margin-left: 8px;\n}\n\n[dir=\"ltr\"] .uppy-StatusBar-statusIndicator{\n  margin-right: 7px;\n}\n\n[dir=\"rtl\"] .uppy-StatusBar-statusIndicator{\n  margin-left: 7px;\n}\n\n.uppy-StatusBar-statusIndicator {\n  position: relative;\n  top: 1px;\n  color: #525252;\n}\n.uppy-StatusBar-statusIndicator svg {\n  vertical-align: text-bottom;\n}\n\n[dir=\"ltr\"] .uppy-StatusBar-actions{\n  right: 10px;\n}\n\n[dir=\"rtl\"] .uppy-StatusBar-actions{\n  left: 10px;\n}\n\n.uppy-StatusBar-actions {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1004;\n  display: flex;\n  align-items: center;\n}\n\n.uppy-StatusBar.is-waiting .uppy-StatusBar-actions {\n  position: static;\n  width: 100%;\n  height: 100%;\n  padding: 0 15px;\n  background-color: #fafafa;\n}\n[data-uppy-theme=dark] .uppy-StatusBar.is-waiting .uppy-StatusBar-actions {\n  background-color: #1f1f1f;\n}\n\n.uppy-StatusBar:not([aria-hidden=true]).is-waiting.has-ghosts {\n  flex-direction: column;\n  height: 90px;\n}\n.uppy-size--md .uppy-StatusBar:not([aria-hidden=true]).is-waiting.has-ghosts {\n  flex-direction: row;\n  height: 65px;\n}\n.uppy-StatusBar:not([aria-hidden=true]).is-waiting.has-ghosts .uppy-StatusBar-actions {\n  flex-direction: column;\n  justify-content: center;\n}\n.uppy-size--md .uppy-StatusBar:not([aria-hidden=true]).is-waiting.has-ghosts .uppy-StatusBar-actions {\n  flex-direction: row;\n  justify-content: initial;\n}\n\n.uppy-StatusBar-actionCircleBtn {\n  margin: 3px;\n  line-height: 1;\n  cursor: pointer;\n  opacity: 0.9;\n}\n.uppy-StatusBar-actionCircleBtn:focus {\n  outline: none;\n}\n.uppy-StatusBar-actionCircleBtn::-moz-focus-inner {\n  border: 0;\n}\n.uppy-StatusBar-actionCircleBtn:focus {\n  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.5);\n}\n[data-uppy-theme=dark] .uppy-StatusBar-actionCircleBtn:focus {\n  outline: none;\n}\n[data-uppy-theme=dark] .uppy-StatusBar-actionCircleBtn::-moz-focus-inner {\n  border: 0;\n}\n[data-uppy-theme=dark] .uppy-StatusBar-actionCircleBtn:focus {\n  box-shadow: 0 0 0 2px rgba(170, 225, 255, 0.85);\n}\n.uppy-StatusBar-actionCircleBtn:hover {\n  opacity: 1;\n}\n.uppy-StatusBar-actionCircleBtn:focus {\n  border-radius: 50%;\n}\n\n.uppy-StatusBar-actionCircleBtn svg {\n  vertical-align: bottom;\n}\n\n.uppy-StatusBar-actionBtn {\n  display: inline-block;\n  color: #1269cf;\n  font-size: 10px;\n  line-height: inherit;\n  vertical-align: middle;\n}\n.uppy-size--md .uppy-StatusBar-actionBtn {\n  font-size: 11px;\n}\n\n.uppy-StatusBar-actionBtn--disabled {\n  opacity: 0.4;\n}\n[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--disabled {\n  opacity: 0.7;\n}\n\n[dir=\"ltr\"] .uppy-StatusBar-actionBtn--retry{\n  margin-right: 6px;\n}\n\n[dir=\"rtl\"] .uppy-StatusBar-actionBtn--retry{\n  margin-left: 6px;\n}\n\n.uppy-StatusBar-actionBtn--retry {\n  position: relative;\n  height: 16px;\n  padding: 1px 6px 3px 18px;\n  color: #fff;\n  line-height: 1;\n  background-color: #ff4b23;\n  border-radius: 8px;\n}\n.uppy-StatusBar-actionBtn--retry:focus {\n  outline: none;\n}\n.uppy-StatusBar-actionBtn--retry::-moz-focus-inner {\n  border: 0;\n}\n.uppy-StatusBar-actionBtn--retry:focus {\n  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.5);\n}\n[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--retry:focus {\n  outline: none;\n}\n[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--retry::-moz-focus-inner {\n  border: 0;\n}\n[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--retry:focus {\n  box-shadow: 0 0 0 2px rgba(170, 225, 255, 0.85);\n}\n.uppy-StatusBar-actionBtn--retry:hover {\n  background-color: #f92d00;\n}\n[dir=\"ltr\"] .uppy-StatusBar-actionBtn--retry svg{\n  left: 6px;\n}\n[dir=\"rtl\"] .uppy-StatusBar-actionBtn--retry svg{\n  right: 6px;\n}\n.uppy-StatusBar-actionBtn--retry svg {\n  position: absolute;\n  top: 3px;\n}\n\n.uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload {\n  width: 100%;\n  padding: 15px 10px;\n  color: #fff;\n  font-size: 14px;\n  line-height: 1;\n  background-color: #1bb240;\n}\n.uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload:hover {\n  background-color: #189c38;\n}\n[data-uppy-theme=dark] .uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload {\n  background-color: #1c8b37;\n}\n[data-uppy-theme=dark] .uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload:hover {\n  background-color: #18762f;\n}\n\n.uppy-size--md .uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload {\n  width: auto;\n  padding: 13px 22px;\n}\n\n.uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload.uppy-StatusBar-actionBtn--disabled:hover {\n  background-color: #1bb240;\n  cursor: not-allowed;\n}\n\n[data-uppy-theme=dark] .uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload.uppy-StatusBar-actionBtn--disabled:hover {\n  background-color: #1c8b37;\n}\n\n.uppy-StatusBar:not(.is-waiting) .uppy-StatusBar-actionBtn--upload {\n  color: #1269cf;\n  background-color: transparent;\n}\n\n[dir=\"ltr\"] .uppy-StatusBar-actionBtn--uploadNewlyAdded{\n  padding-right: 3px;\n}\n\n[dir=\"rtl\"] .uppy-StatusBar-actionBtn--uploadNewlyAdded{\n  padding-left: 3px;\n}\n\n[dir=\"ltr\"] .uppy-StatusBar-actionBtn--uploadNewlyAdded{\n  padding-left: 3px;\n}\n\n[dir=\"rtl\"] .uppy-StatusBar-actionBtn--uploadNewlyAdded{\n  padding-right: 3px;\n}\n\n.uppy-StatusBar-actionBtn--uploadNewlyAdded {\n  padding-bottom: 1px;\n  border-radius: 3px;\n}\n.uppy-StatusBar-actionBtn--uploadNewlyAdded:focus {\n  outline: none;\n}\n.uppy-StatusBar-actionBtn--uploadNewlyAdded::-moz-focus-inner {\n  border: 0;\n}\n.uppy-StatusBar-actionBtn--uploadNewlyAdded:focus {\n  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.5);\n}\n[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--uploadNewlyAdded:focus {\n  outline: none;\n}\n[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--uploadNewlyAdded::-moz-focus-inner {\n  border: 0;\n}\n[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--uploadNewlyAdded:focus {\n  box-shadow: 0 0 0 2px rgba(170, 225, 255, 0.85);\n}\n.uppy-StatusBar.is-preprocessing .uppy-StatusBar-actionBtn--uploadNewlyAdded, .uppy-StatusBar.is-postprocessing .uppy-StatusBar-actionBtn--uploadNewlyAdded {\n  display: none;\n}\n\n.uppy-StatusBar-actionBtn--done {\n  padding: 7px 8px;\n  line-height: 1;\n  border-radius: 3px;\n}\n.uppy-StatusBar-actionBtn--done:focus {\n  outline: none;\n}\n.uppy-StatusBar-actionBtn--done::-moz-focus-inner {\n  border: 0;\n}\n.uppy-StatusBar-actionBtn--done:hover {\n  color: #0e51a0;\n}\n.uppy-StatusBar-actionBtn--done:focus {\n  background-color: #dfe6f1;\n}\n[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--done:focus {\n  background-color: #333;\n}\n[data-uppy-theme=dark] .uppy-StatusBar-actionBtn--done {\n  color: #02baf2;\n}\n\n.uppy-size--md .uppy-StatusBar-actionBtn--done {\n  font-size: 14px;\n}\n\n.uppy-StatusBar-serviceMsg {\n  padding-left: 10px;\n  color: #000;\n  font-size: 11px;\n  line-height: 1.1;\n}\n.uppy-size--md .uppy-StatusBar-serviceMsg {\n  padding-left: 15px;\n  font-size: 14px;\n}\n[data-uppy-theme=dark] .uppy-StatusBar-serviceMsg {\n  color: #eaeaea;\n}\n\n.uppy-StatusBar-serviceMsg-ghostsIcon {\n  position: relative;\n  top: 2px;\n  left: 6px;\n  width: 10px;\n  vertical-align: text-bottom;\n  opacity: 0.5;\n}\n.uppy-size--md .uppy-StatusBar-serviceMsg-ghostsIcon {\n  top: 1px;\n  left: 10px;\n  width: 15px;\n}\n\n[dir=\"ltr\"] .uppy-StatusBar-details{\n  left: 2px;\n}\n\n[dir=\"rtl\"] .uppy-StatusBar-details{\n  right: 2px;\n}\n\n.uppy-StatusBar-details {\n  position: relative;\n  top: 0;\n  display: inline-block;\n  width: 13px;\n  height: 13px;\n  color: #fff;\n  font-weight: 600;\n  font-size: 10px;\n  line-height: 12px;\n  text-align: center;\n  vertical-align: middle;\n  background-color: #939393;\n  border-radius: 50%;\n  cursor: help;\n  -webkit-appearance: none;\n          appearance: none;\n}\n\n.uppy-StatusBar-details::after {\n  line-height: 1.3;\n  word-wrap: break-word;\n}\n\n[dir=\"ltr\"] .uppy-StatusBar-spinner{\n  margin-right: 10px;\n}\n\n[dir=\"rtl\"] .uppy-StatusBar-spinner{\n  margin-left: 10px;\n}\n\n.uppy-StatusBar-spinner {\n  animation-name: uppy-StatusBar-spinnerAnimation;\n  animation-duration: 1s;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite;\n  fill: #1269cf;\n}\n\n.uppy-StatusBar.is-preprocessing .uppy-StatusBar-spinner,\n.uppy-StatusBar.is-postprocessing .uppy-StatusBar-spinner {\n  fill: #f6a623;\n}\n\n@keyframes uppy-StatusBar-spinnerAnimation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.uppy-ProviderBrowser-viewType--grid ul.uppy-ProviderBrowser-list,\n.uppy-ProviderBrowser-viewType--unsplash ul.uppy-ProviderBrowser-list {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 6px;\n}\n.uppy-ProviderBrowser-viewType--grid ul.uppy-ProviderBrowser-list::after,\n.uppy-ProviderBrowser-viewType--unsplash ul.uppy-ProviderBrowser-list::after {\n  flex: auto;\n  content: \"\";\n}\n.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem,\n.uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem {\n  position: relative;\n  width: 50%;\n  margin: 0;\n}\n.uppy-size--md .uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem,\n.uppy-size--md .uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem {\n  width: 33.3333%;\n}\n.uppy-size--lg .uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem,\n.uppy-size--lg .uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem {\n  width: 25%;\n}\n.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem::before,\n.uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem::before {\n  display: block;\n  padding-top: 100%;\n  content: \"\";\n}\n.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--selected img,\n.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--selected svg,\n.uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem--selected img,\n.uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem--selected svg {\n  opacity: 0.85;\n}\n.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--disabled,\n.uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem--disabled {\n  opacity: 0.5;\n}\n.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--noPreview .uppy-ProviderBrowserItem-inner,\n.uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem--noPreview .uppy-ProviderBrowserItem-inner {\n  background-color: rgba(147, 147, 147, 0.2);\n}\n[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--noPreview .uppy-ProviderBrowserItem-inner,\n[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem--noPreview .uppy-ProviderBrowserItem-inner {\n  background-color: rgba(234, 234, 234, 0.2);\n}\n.uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--noPreview svg,\n.uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem--noPreview svg {\n  width: 30%;\n  height: 30%;\n  fill: rgba(0, 0, 0, 0.7);\n}\n[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--grid li.uppy-ProviderBrowserItem--noPreview svg,\n[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--unsplash li.uppy-ProviderBrowserItem--noPreview svg {\n  fill: rgba(255, 255, 255, 0.8);\n}\n.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-inner,\n.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-inner {\n  position: absolute;\n  top: 7px;\n  right: 7px;\n  bottom: 7px;\n  left: 7px;\n  width: calc(100% - 14px);\n  height: calc(100% - 14px);\n  overflow: hidden;\n  text-align: center;\n  border-radius: 4px;\n}\n@media (hover: none) {\n  .uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-inner .uppy-ProviderBrowserItem-author,\n  .uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-inner .uppy-ProviderBrowserItem-author {\n    display: block;\n  }\n}\n[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-inner,\n[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-inner {\n  box-shadow: 0 0 0 3px rgba(170, 225, 255, 0.7);\n}\n.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-inner img,\n.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-inner img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 4px;\n}\n.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-author,\n.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-author {\n  position: absolute;\n  display: none;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background: rgba(0, 0, 0, 0.3);\n  color: white;\n  font-weight: 500;\n  font-size: 12px;\n  margin: 0;\n  padding: 5px;\n  text-decoration: none;\n}\n.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-author:hover,\n.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-author:hover {\n  background: rgba(0, 0, 0, 0.4);\n  text-decoration: underline;\n}\n.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox,\n.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  z-index: 1002;\n  width: 26px;\n  height: 26px;\n  background-color: #1269cf;\n  border-radius: 50%;\n  opacity: 0;\n}\n[dir=\"ltr\"] .uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox::after,[dir=\"ltr\"] \n.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox::after{\n  left: 7px;\n}\n[dir=\"rtl\"] .uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox::after,[dir=\"rtl\"] \n.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox::after{\n  right: 7px;\n}\n.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox::after,\n.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox::after {\n  top: 8px;\n  width: 12px;\n  height: 7px;\n}\n.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem--is-checked .uppy-ProviderBrowserItem-checkbox,\n.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem--is-checked .uppy-ProviderBrowserItem-checkbox {\n  opacity: 1;\n}\n.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox--grid:hover + label .uppy-ProviderBrowserItem-author,\n.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox--grid:focus + label .uppy-ProviderBrowserItem-author,\n.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox--grid:hover + label .uppy-ProviderBrowserItem-author,\n.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox--grid:focus + label .uppy-ProviderBrowserItem-author {\n  display: block;\n}\n.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox--grid:focus + label,\n.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox--grid:focus + label {\n  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.5);\n}\n.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox--grid:focus + label:focus,\n.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox--grid:focus + label:focus {\n  outline: none;\n}\n.uppy-ProviderBrowser-viewType--grid .uppy-ProviderBrowserItem-checkbox--grid:focus + label::-moz-focus-inner,\n.uppy-ProviderBrowser-viewType--unsplash .uppy-ProviderBrowserItem-checkbox--grid:focus + label::-moz-focus-inner {\n  border: 0;\n}\n\n.uppy-ProviderBrowser-viewType--list {\n  background-color: #fff;\n}\n[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--list {\n  background-color: #1f1f1f;\n}\n.uppy-ProviderBrowser-viewType--list li.uppy-ProviderBrowserItem {\n  display: flex;\n  align-items: center;\n  margin: 0;\n  padding: 7px 15px;\n}\n[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--list li.uppy-ProviderBrowserItem {\n  color: #eaeaea;\n}\n.uppy-ProviderBrowser-viewType--list li.uppy-ProviderBrowserItem--disabled {\n  opacity: 0.6;\n}\n[dir=\"ltr\"] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox{\n  margin-right: 15px;\n}\n[dir=\"rtl\"] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox{\n  margin-left: 15px;\n}\n.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox {\n  width: 17px;\n  height: 17px;\n  background-color: #fff;\n  border: 1px solid #cfcfcf;\n  border-radius: 3px;\n}\n.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox:focus {\n  border: 1px solid #1269cf;\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.25);\n}\n[dir=\"ltr\"] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox::after{\n  left: 3px;\n}\n[dir=\"rtl\"] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox::after{\n  right: 3px;\n}\n.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox::after {\n  top: 4px;\n  width: 9px;\n  height: 5px;\n  opacity: 0;\n}\n[data-uppy-theme=dark] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-checkbox:focus {\n  border-color: rgba(2, 186, 242, 0.7);\n  box-shadow: 0 0 0 3px rgba(2, 186, 242, 0.2);\n}\n.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem--is-checked .uppy-ProviderBrowserItem-checkbox,\n.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem--is-partial .uppy-ProviderBrowserItem-checkbox {\n  background-color: #1269cf;\n  border-color: #1269cf;\n}\n.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem--is-checked .uppy-ProviderBrowserItem-checkbox::after,\n.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem--is-partial .uppy-ProviderBrowserItem-checkbox::after {\n  opacity: 1;\n}\n.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner {\n  display: flex;\n  align-items: center;\n  color: inherit;\n  font-family: -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", \"Segoe UI Symbol\", \"Segoe UI Emoji\", \"Apple Color Emoji\", Roboto, Helvetica, Arial, sans-serif;\n  padding: 2px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner:focus {\n  text-decoration: underline;\n  outline: none;\n}\n[dir=\"ltr\"] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner img,[dir=\"ltr\"] \n.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner svg{\n  margin-right: 8px;\n}\n[dir=\"rtl\"] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner img,[dir=\"rtl\"] \n.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner svg{\n  margin-left: 8px;\n}\n.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-inner span {\n  overflow: hidden;\n  line-height: 1.2;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem--disabled .uppy-ProviderBrowserItem-inner {\n  cursor: default;\n}\n[dir=\"ltr\"] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-iconWrap{\n  margin-right: 7px;\n}\n[dir=\"rtl\"] .uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-iconWrap{\n  margin-left: 7px;\n}\n.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem-iconWrap {\n  width: 20px;\n}\n\n.uppy-ProviderBrowserItem-checkbox {\n  position: relative;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n.uppy-ProviderBrowserItem-checkbox:disabled {\n  cursor: default;\n}\n.uppy-ProviderBrowserItem-checkbox:disabled::after {\n  cursor: default;\n}\n[data-uppy-theme=dark] .uppy-ProviderBrowserItem-checkbox {\n  background-color: #1f1f1f;\n  border-color: #939393;\n}\n\n[data-uppy-theme=dark] .uppy-ProviderBrowserItem--is-checked .uppy-ProviderBrowserItem-checkbox {\n  background-color: #333;\n}\n.uppy-ProviderBrowserItem--is-checked .uppy-ProviderBrowserItem-checkbox::after {\n  position: absolute;\n  border-bottom: 2px solid #eaeaea;\n  border-left: 2px solid #eaeaea;\n  transform: rotate(-45deg);\n  cursor: pointer;\n  content: \"\";\n}\n\n.uppy-ProviderBrowserItem--is-partial .uppy-ProviderBrowserItem-checkbox::after {\n  content: \"\" !important;\n  position: absolute !important;\n  top: 50% !important;\n  left: 20% !important;\n  right: 20% !important;\n  height: 2px !important;\n  background-color: #eaeaea !important;\n  transform: translateY(-50%) !important;\n}\n\n.uppy-SearchProvider {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n[data-uppy-theme=dark] .uppy-SearchProvider {\n  background-color: #1f1f1f;\n}\n\n.uppy-SearchProvider-input {\n  width: 90%;\n  max-width: 650px;\n  margin-bottom: 15px;\n}\n.uppy-size--md .uppy-SearchProvider-input {\n  margin-bottom: 20px;\n}\n.uppy-SearchProvider-input::-webkit-search-cancel-button {\n  display: none;\n}\n\n.uppy-SearchProvider-searchButton {\n  padding: 13px 25px;\n}\n.uppy-size--md .uppy-SearchProvider-searchButton {\n  padding: 13px 30px;\n}\n\n.uppy-DashboardContent-panelBody {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n}\n[data-uppy-theme=dark] .uppy-DashboardContent-panelBody {\n  background-color: #1f1f1f;\n}\n\n.uppy-Provider-auth,\n.uppy-Provider-error,\n.uppy-Provider-loading,\n.uppy-Provider-empty {\n  display: flex;\n  flex: 1;\n  flex-flow: column wrap;\n  align-items: center;\n  justify-content: center;\n  color: #939393;\n}\n\n.uppy-Provider-empty {\n  color: #939393;\n}\n\n.uppy-Provider-authIcon svg {\n  width: 100px;\n  height: 75px;\n}\n\n.uppy-Provider-authTitle {\n  max-width: 500px;\n  margin-bottom: 30px;\n  padding: 0 15px;\n  color: #757575;\n  font-weight: 400;\n  font-size: 17px;\n  line-height: 1.4;\n  text-align: center;\n}\n.uppy-size--md .uppy-Provider-authTitle {\n  font-size: 20px;\n}\n[data-uppy-theme=dark] .uppy-Provider-authTitle {\n  color: #cfcfcf;\n}\n\n.uppy-Provider-btn-google {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px !important;\n  background: #4285f4;\n}\n.uppy-Provider-btn-google:hover {\n  background-color: #1266f1;\n}\n.uppy-Provider-btn-google:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.4);\n}\n.uppy-Provider-btn-google svg {\n  margin-right: 8px;\n}\n\n[dir=\"ltr\"] .uppy-Provider-breadcrumbs{\n  text-align: left;\n}\n\n[dir=\"rtl\"] .uppy-Provider-breadcrumbs{\n  text-align: right;\n}\n\n.uppy-Provider-breadcrumbs {\n  flex: 1;\n  margin-bottom: 10px;\n  color: #525252;\n  font-size: 12px;\n}\n.uppy-size--md .uppy-Provider-breadcrumbs {\n  margin-bottom: 0;\n}\n[data-uppy-theme=dark] .uppy-Provider-breadcrumbs {\n  color: #eaeaea;\n}\n\n[dir=\"ltr\"] .uppy-Provider-breadcrumbsIcon{\n  margin-right: 4px;\n}\n\n[dir=\"rtl\"] .uppy-Provider-breadcrumbsIcon{\n  margin-left: 4px;\n}\n\n.uppy-Provider-breadcrumbsIcon {\n  display: inline-block;\n  color: #525252;\n  line-height: 1;\n  vertical-align: middle;\n}\n\n.uppy-Provider-breadcrumbsIcon svg {\n  width: 13px;\n  height: 13px;\n  fill: #525252;\n}\n\n.uppy-Provider-breadcrumbs button {\n  display: inline-block;\n  padding: 4px;\n  line-height: inherit;\n  border-radius: 3px;\n}\n.uppy-Provider-breadcrumbs button:focus {\n  outline: none;\n}\n.uppy-Provider-breadcrumbs button::-moz-focus-inner {\n  border: 0;\n}\n.uppy-Provider-breadcrumbs button:hover {\n  color: #0e51a0;\n}\n.uppy-Provider-breadcrumbs button:focus {\n  background-color: #dfe6f1;\n}\n[data-uppy-theme=dark] .uppy-Provider-breadcrumbs button:focus {\n  background-color: #333;\n}\n.uppy-Provider-breadcrumbs button:not(:last-of-type) {\n  text-decoration: underline;\n}\n.uppy-Provider-breadcrumbs button:last-of-type {\n  color: #333;\n  font-weight: 500;\n  cursor: normal;\n  pointer-events: none;\n}\n.uppy-Provider-breadcrumbs button:hover {\n  cursor: pointer;\n}\n[data-uppy-theme=dark] .uppy-Provider-breadcrumbs button {\n  color: #eaeaea;\n}\n\n.uppy-ProviderBrowser {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  height: 100%;\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.uppy-ProviderBrowser-user {\n  margin: 0 8px 0 0;\n  color: #333;\n  font-weight: 500;\n}\n[data-uppy-theme=dark] .uppy-ProviderBrowser-user {\n  color: #eaeaea;\n}\n\n[dir=\"ltr\"] .uppy-ProviderBrowser-user::after{\n  left: 4px;\n}\n\n[dir=\"rtl\"] .uppy-ProviderBrowser-user::after{\n  right: 4px;\n}\n\n.uppy-ProviderBrowser-user::after {\n  position: relative;\n  color: #939393;\n  font-weight: normal;\n  content: \"·\";\n}\n\n.uppy-ProviderBrowser-header {\n  position: relative;\n  z-index: 1001;\n  border-bottom: 1px solid #eaeaea;\n}\n[data-uppy-theme=dark] .uppy-ProviderBrowser-header {\n  border-bottom: 1px solid #333;\n}\n\n.uppy-ProviderBrowser-headerBar {\n  z-index: 1001;\n  padding: 7px 15px;\n  color: #757575;\n  font-size: 12px;\n  line-height: 1.4;\n  background-color: #fafafa;\n}\n.uppy-size--md .uppy-ProviderBrowser-headerBar {\n  display: flex;\n  align-items: center;\n}\n[data-uppy-theme=dark] .uppy-ProviderBrowser-headerBar {\n  background-color: #1f1f1f;\n}\n\n.uppy-ProviderBrowser-headerBar--simple {\n  display: block;\n  justify-content: center;\n  text-align: center;\n}\n\n.uppy-ProviderBrowser-headerBar--simple .uppy-Provider-breadcrumbsWrap {\n  display: inline-block;\n  flex: none;\n  vertical-align: middle;\n}\n\n.uppy-ProviderBrowser-searchFilter {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 30px;\n  padding-left: 8px;\n  padding-right: 8px;\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n\n[dir=\"ltr\"] .uppy-ProviderBrowser-searchFilterInput{\n  padding-left: 30px;\n}\n\n[dir=\"rtl\"] .uppy-ProviderBrowser-searchFilterInput{\n  padding-right: 30px;\n}\n\n[dir=\"ltr\"] .uppy-ProviderBrowser-searchFilterInput{\n  padding-right: 30px;\n}\n\n[dir=\"rtl\"] .uppy-ProviderBrowser-searchFilterInput{\n  padding-left: 30px;\n}\n\n.uppy-ProviderBrowser-searchFilterInput {\n  z-index: 1001;\n  width: 100%;\n  height: 30px;\n  font-size: 13px;\n  font-family: -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", \"Segoe UI Symbol\", \"Segoe UI Emoji\", \"Apple Color Emoji\", Roboto, Helvetica, Arial, sans-serif;\n  line-height: 1.4;\n  background-color: #eaeaea;\n  border: 0;\n  border-radius: 4px;\n  outline: 0;\n  color: #333;\n}\n.uppy-ProviderBrowser-searchFilterInput::-webkit-search-cancel-button {\n  display: none;\n}\n[data-uppy-theme=dark] .uppy-ProviderBrowser-searchFilterInput {\n  color: #eaeaea;\n  background-color: #1f1f1f;\n}\n\n.uppy-ProviderBrowser-searchFilterInput:focus {\n  background-color: #cfcfcf;\n  border: 0;\n}\n[data-uppy-theme=dark] .uppy-ProviderBrowser-searchFilterInput:focus {\n  background-color: #333;\n}\n\n[dir=\"ltr\"] .uppy-ProviderBrowser-searchFilterIcon{\n  left: 16px;\n}\n\n[dir=\"rtl\"] .uppy-ProviderBrowser-searchFilterIcon{\n  right: 16px;\n}\n\n.uppy-ProviderBrowser-searchFilterIcon {\n  position: absolute;\n  z-index: 1002;\n  width: 12px;\n  height: 12px;\n  color: #757575;\n}\n\n.uppy-ProviderBrowser-searchFilterInput::placeholder {\n  color: #939393;\n  opacity: 1;\n}\n\n[dir=\"ltr\"] .uppy-ProviderBrowser-searchFilterReset{\n  right: 16px;\n}\n\n[dir=\"rtl\"] .uppy-ProviderBrowser-searchFilterReset{\n  left: 16px;\n}\n\n.uppy-ProviderBrowser-searchFilterReset {\n  border-radius: 3px;\n  position: absolute;\n  z-index: 1002;\n  width: 22px;\n  height: 22px;\n  padding: 6px;\n  color: #939393;\n  cursor: pointer;\n}\n.uppy-ProviderBrowser-searchFilterReset:focus {\n  outline: none;\n}\n.uppy-ProviderBrowser-searchFilterReset::-moz-focus-inner {\n  border: 0;\n}\n.uppy-ProviderBrowser-searchFilterReset:focus {\n  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.5);\n}\n.uppy-ProviderBrowser-searchFilterReset:hover {\n  color: #757575;\n}\n.uppy-ProviderBrowser-searchFilterReset svg {\n  vertical-align: text-top;\n}\n\n.uppy-ProviderBrowser-userLogout {\n  padding: 4px;\n  color: #1269cf;\n  line-height: inherit;\n  border-radius: 3px;\n  cursor: pointer;\n}\n.uppy-ProviderBrowser-userLogout:focus {\n  outline: none;\n}\n.uppy-ProviderBrowser-userLogout::-moz-focus-inner {\n  border: 0;\n}\n.uppy-ProviderBrowser-userLogout:hover {\n  color: #0e51a0;\n}\n.uppy-ProviderBrowser-userLogout:focus {\n  background-color: #dfe6f1;\n}\n[data-uppy-theme=dark] .uppy-ProviderBrowser-userLogout:focus {\n  background-color: #333;\n}\n.uppy-ProviderBrowser-userLogout:hover {\n  text-decoration: underline;\n}\n[data-uppy-theme=dark] .uppy-ProviderBrowser-userLogout {\n  color: #eaeaea;\n}\n\n.uppy-ProviderBrowser-body {\n  position: relative;\n  flex: 1;\n}\n\n.uppy-ProviderBrowser-list {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  list-style: none;\n  background-color: #fff;\n  border-spacing: 0;\n  -webkit-overflow-scrolling: touch;\n}\n[data-uppy-theme=dark] .uppy-ProviderBrowser-list {\n  background-color: #1f1f1f;\n}\n.uppy-ProviderBrowser-list:focus {\n  outline: none;\n}\n\n.uppy-ProviderBrowserItem-inner {\n  font-weight: 500;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.uppy-ProviderBrowser-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 15px;\n  background-color: #fff;\n  border-top: 1px solid #eaeaea;\n}\n[dir=\"ltr\"] .uppy-ProviderBrowser-footer button{\n  margin-right: 8px;\n}\n[dir=\"rtl\"] .uppy-ProviderBrowser-footer button{\n  margin-left: 8px;\n}\n[data-uppy-theme=dark] .uppy-ProviderBrowser-footer {\n  background-color: #1f1f1f;\n  border-top: 1px solid #333;\n}\n\n.uppy-ProviderBrowser-footer-buttons {\n  flex-shrink: 0;\n}\n\n.uppy-ProviderBrowser-footer-error {\n  color: #e32437;\n  line-height: 18px;\n}\n\n@media (max-width: 426px) {\n  .uppy-ProviderBrowser-footer {\n    flex-direction: column-reverse;\n    align-items: stretch;\n  }\n  .uppy-ProviderBrowser-footer-error {\n    padding-bottom: 10px;\n  }\n}\n/* https://stackoverflow.com/a/33082658/6519037 */\n.picker-dialog-bg {\n  z-index: 20000 !important;\n}\n\n.picker-dialog {\n  z-index: 20001 !important;\n}\n\n.uppy-Dashboard-Item-previewInnerWrap {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  border-radius: 3px;\n  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.4);\n}\n.uppy-size--md .uppy-Dashboard-Item-previewInnerWrap {\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);\n}\n.uppy-Dashboard--singleFile .uppy-Dashboard-Item-previewInnerWrap {\n  box-shadow: none;\n}\n\n.uppy-Dashboard-Item-previewInnerWrap::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1001;\n  display: none;\n  background-color: rgba(0, 0, 0, 0.65);\n  content: \"\";\n}\n\n.uppy-Dashboard-Item-previewLink {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1002;\n}\n.uppy-Dashboard-Item-previewLink:focus {\n  box-shadow: inset 0 0 0 3px #579df0;\n}\n[data-uppy-theme=dark] .uppy-Dashboard-Item-previewLink:focus {\n  box-shadow: inset 0 0 0 3px #016c8d;\n}\n\n.uppy-Dashboard-Item-preview img.uppy-Dashboard-Item-previewImg {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 3px;\n  transform: translateZ(0);\n}\n.uppy-Dashboard--singleFile .uppy-Dashboard-Item-preview img.uppy-Dashboard-Item-previewImg {\n  object-fit: contain;\n  width: auto;\n  height: auto;\n  max-width: 100%;\n  max-height: 100%;\n  padding: 10px;\n}\n\n.uppy-Dashboard-Item-progress {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 1002;\n  width: 120px;\n  color: #fff;\n  text-align: center;\n  transform: translate(-50%, -50%);\n  transition: all 0.35 ease;\n}\n\n.uppy-Dashboard-Item-progressIndicator {\n  display: inline-block;\n  width: 38px;\n  height: 38px;\n  opacity: 0.9;\n  color: #fff;\n}\n.uppy-size--md .uppy-Dashboard-Item-progressIndicator {\n  width: 55px;\n  height: 55px;\n}\n\nbutton.uppy-Dashboard-Item-progressIndicator {\n  cursor: pointer;\n}\nbutton.uppy-Dashboard-Item-progressIndicator:focus {\n  outline: none;\n}\nbutton.uppy-Dashboard-Item-progressIndicator::-moz-focus-inner {\n  border: 0;\n}\nbutton.uppy-Dashboard-Item-progressIndicator:focus .uppy-Dashboard-Item-progressIcon--bg,\nbutton.uppy-Dashboard-Item-progressIndicator:focus .uppy-Dashboard-Item-progressIcon--retry {\n  fill: #579df0;\n}\n\n.uppy-Dashboard-Item-progressIcon--circle {\n  width: 100%;\n  height: 100%;\n}\n\n.uppy-Dashboard-Item-progressIcon--bg {\n  stroke: rgba(255, 255, 255, 0.4);\n}\n\n.uppy-Dashboard-Item-progressIcon--progress {\n  transition: stroke-dashoffset 0.5s ease-out;\n  stroke: #fff;\n}\n\n.uppy-Dashboard-Item-progressIcon--play {\n  transition: all 0.2s;\n  fill: #fff;\n  stroke: #fff;\n}\n\n.uppy-Dashboard-Item-progressIcon--cancel {\n  transition: all 0.2s;\n  fill: #fff;\n}\n\n.uppy-Dashboard-Item-progressIcon--pause {\n  transition: all 0.2s;\n  fill: #fff;\n  stroke: #fff;\n}\n\n.uppy-Dashboard-Item-progressIcon--check {\n  transition: all 0.2s;\n  fill: #fff;\n}\n\n.uppy-Dashboard-Item-progressIcon--retry {\n  fill: #fff;\n}\n\n[dir=\"ltr\"] .uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progress{\n  right: -8px;\n}\n\n[dir=\"rtl\"] .uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progress{\n  left: -8px;\n}\n\n[dir=\"ltr\"] .uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progress{\n  left: initial;\n}\n\n[dir=\"rtl\"] .uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progress{\n  right: initial;\n}\n\n.uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progress {\n  top: -9px;\n  width: auto;\n  transform: initial;\n}\n\n.uppy-Dashboard-Item.is-error .uppy-Dashboard-Item-progressIndicator {\n  width: 18px;\n  height: 18px;\n}\n.uppy-size--md .uppy-Dashboard-Item.is-error .uppy-Dashboard-Item-progressIndicator {\n  width: 28px;\n  height: 28px;\n}\n\n.uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progressIndicator {\n  width: 18px;\n  height: 18px;\n  opacity: 1;\n}\n.uppy-size--md .uppy-Dashboard-Item.is-complete .uppy-Dashboard-Item-progressIndicator {\n  width: 22px;\n  height: 22px;\n}\n\n.uppy-Dashboard-Item.is-processing .uppy-Dashboard-Item-progress {\n  opacity: 0;\n}\n\n[dir=\"ltr\"] .uppy-Dashboard-Item-fileInfo{\n  padding-right: 5px;\n}\n\n[dir=\"rtl\"] .uppy-Dashboard-Item-fileInfo{\n  padding-left: 5px;\n}\n[dir=\"ltr\"] .uppy-Dashboard--singleFile .uppy-Dashboard-Item-fileInfo{\n  padding-right: 10px;\n}\n[dir=\"rtl\"] .uppy-Dashboard--singleFile .uppy-Dashboard-Item-fileInfo{\n  padding-left: 10px;\n}\n[dir=\"ltr\"] .uppy-size--md.uppy-Dashboard--singleFile .uppy-Dashboard-Item-fileInfo{\n  padding-right: 15px;\n}\n[dir=\"rtl\"] .uppy-size--md.uppy-Dashboard--singleFile .uppy-Dashboard-Item-fileInfo{\n  padding-left: 15px;\n}\n\n.uppy-Dashboard-Item-name {\n  margin-bottom: 5px;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 1.3;\n  word-wrap: anywhere;\n  word-break: break-all;\n}\n[data-uppy-theme=dark] .uppy-Dashboard-Item-name {\n  color: #eaeaea;\n}\n.uppy-size--md.uppy-Dashboard--singleFile .uppy-Dashboard-Item-name {\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.uppy-Dashboard-Item-fileName {\n  display: flex;\n  align-items: baseline;\n}\n.uppy-Dashboard-Item-fileName button {\n  margin-left: 5px;\n}\n\n.uppy-Dashboard-Item-author {\n  color: #757575;\n  vertical-align: bottom;\n  font-size: 11px;\n  font-weight: normal;\n  display: inline-block;\n  line-height: 1;\n  margin-bottom: 5px;\n}\n.uppy-Dashboard-Item-author a {\n  color: #757575;\n}\n\n.uppy-Dashboard-Item-status {\n  color: #757575;\n  font-weight: normal;\n  font-size: 11px;\n  line-height: 1;\n}\n[data-uppy-theme=dark] .uppy-Dashboard-Item-status {\n  color: #bbb;\n}\n\n.uppy-Dashboard-Item-statusSize {\n  display: inline-block;\n  text-transform: uppercase;\n  vertical-align: bottom;\n  margin-bottom: 5px;\n}\n\n.uppy-Dashboard-Item-reSelect {\n  color: #1269cf;\n  font-weight: 600;\n  font-size: inherit;\n  font-family: inherit;\n}\n\n.uppy-Dashboard-Item-errorMessage {\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1.3;\n  color: #a51523;\n  background-color: #fdeff1;\n  padding: 5px 6px;\n}\n\n.uppy-Dashboard-Item-errorMessageBtn {\n  font-size: 11px;\n  text-decoration: underline;\n  color: #a51523;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.uppy-Dashboard-Item-preview .uppy-Dashboard-Item-errorMessage {\n  display: none;\n}\n.uppy-size--md .uppy-Dashboard-Item-preview .uppy-Dashboard-Item-errorMessage {\n  display: block;\n  border-top: 1px solid #f7c2c8;\n  padding: 6px 8px;\n  line-height: 1.4;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n}\n\n.uppy-Dashboard-Item-fileInfo .uppy-Dashboard-Item-errorMessage {\n  display: inline-block;\n  position: static;\n  border: 1px solid #f7c2c8;\n  border-radius: 3px;\n}\n.uppy-size--md .uppy-Dashboard-Item-fileInfo .uppy-Dashboard-Item-errorMessage {\n  display: none;\n}\n\n.uppy-Dashboard-Item-action {\n  color: #939393;\n  cursor: pointer;\n}\n.uppy-Dashboard-Item-action:focus {\n  outline: none;\n}\n.uppy-Dashboard-Item-action::-moz-focus-inner {\n  border: 0;\n}\n.uppy-Dashboard-Item-action:focus {\n  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.5);\n}\n.uppy-Dashboard-Item-action:hover {\n  color: #1f1f1f;\n  opacity: 1;\n}\n[data-uppy-theme=dark] .uppy-Dashboard-Item-action {\n  color: #cfcfcf;\n}\n[data-uppy-theme=dark] .uppy-Dashboard-Item-action:focus {\n  outline: none;\n}\n[data-uppy-theme=dark] .uppy-Dashboard-Item-action::-moz-focus-inner {\n  border: 0;\n}\n[data-uppy-theme=dark] .uppy-Dashboard-Item-action:focus {\n  box-shadow: 0 0 0 2px rgba(170, 225, 255, 0.85);\n}\n[data-uppy-theme=dark] .uppy-Dashboard-Item-action:hover {\n  color: #eaeaea;\n}\n\n.uppy-Dashboard-Item-action--remove {\n  color: #1f1f1f;\n  opacity: 0.95;\n}\n.uppy-Dashboard-Item-action--remove:hover {\n  color: #000;\n  opacity: 1;\n}\n[dir=\"ltr\"] .uppy-size--md .uppy-Dashboard-Item-action--remove{\n  right: -8px;\n}\n[dir=\"rtl\"] .uppy-size--md .uppy-Dashboard-Item-action--remove{\n  left: -8px;\n}\n.uppy-size--md .uppy-Dashboard-Item-action--remove {\n  position: absolute;\n  top: -8px;\n  z-index: 1002;\n  width: 18px;\n  height: 18px;\n  padding: 0;\n}\n.uppy-size--md .uppy-Dashboard-Item-action--remove:focus {\n  border-radius: 50%;\n}\n[dir=\"ltr\"] .uppy-Dashboard--singleFile.uppy-size--height-md .uppy-Dashboard-Item-action--remove{\n  right: 8px;\n}\n[dir=\"rtl\"] .uppy-Dashboard--singleFile.uppy-size--height-md .uppy-Dashboard-Item-action--remove{\n  left: 8px;\n}\n.uppy-Dashboard--singleFile.uppy-size--height-md .uppy-Dashboard-Item-action--remove {\n  position: absolute;\n  top: 8px;\n}\n[data-uppy-theme=dark] .uppy-Dashboard-Item-action--remove {\n  color: #525252;\n}\n[data-uppy-theme=dark] .uppy-Dashboard-Item-action--remove:hover {\n  color: #333;\n}\n\n.uppy-Dashboard:not(.uppy-size--md):not(.uppy-Dashboard--singleFile.uppy-size--height-md) .uppy-Dashboard-Item-actionWrapper {\n  display: flex;\n  align-items: center;\n}\n.uppy-Dashboard:not(.uppy-size--md):not(.uppy-Dashboard--singleFile.uppy-size--height-md) .uppy-Dashboard-Item-action {\n  width: 22px;\n  height: 22px;\n  margin-left: 3px;\n  padding: 3px;\n}\n.uppy-Dashboard:not(.uppy-size--md):not(.uppy-Dashboard--singleFile.uppy-size--height-md) .uppy-Dashboard-Item-action:focus {\n  border-radius: 3px;\n}\n\n.uppy-size--md .uppy-Dashboard-Item-action--copyLink,\n.uppy-size--md .uppy-Dashboard-Item-action--edit {\n  width: 16px;\n  height: 16px;\n  padding: 0;\n}\n.uppy-size--md .uppy-Dashboard-Item-action--copyLink:focus,\n.uppy-size--md .uppy-Dashboard-Item-action--edit:focus {\n  border-radius: 3px;\n}\n\n.uppy-Dashboard-Item {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  border-bottom: 1px solid #eaeaea;\n}\n[dir=\"ltr\"] .uppy-Dashboard:not(.uppy-Dashboard--singleFile) .uppy-Dashboard-Item{\n  padding-right: 0;\n}\n[dir=\"rtl\"] .uppy-Dashboard:not(.uppy-Dashboard--singleFile) .uppy-Dashboard-Item{\n  padding-left: 0;\n}\n[data-uppy-theme=dark] .uppy-Dashboard-Item {\n  border-bottom: 1px solid #333;\n}\n[dir=\"ltr\"] .uppy-size--md .uppy-Dashboard-Item{\n  float: left;\n}\n[dir=\"rtl\"] .uppy-size--md .uppy-Dashboard-Item{\n  float: right;\n}\n.uppy-size--md .uppy-Dashboard-Item {\n  position: relative;\n  display: block;\n  /* When changing width: also update `itemsPerRow` values in `src/components/Dashboard.js`. */\n  width: calc(33.333% - 15px - 15px);\n  height: 215px;\n  margin: 5px 15px;\n  padding: 0;\n  border-bottom: 0;\n}\n.uppy-size--lg .uppy-Dashboard-Item {\n  /* When changing width: also update `itemsPerRow` values in `src/components/Dashboard.js`. */\n  width: calc(25% - 15px - 15px);\n  height: 190px;\n  margin: 5px 15px;\n  padding: 0;\n}\n.uppy-size--xl .uppy-Dashboard-Item {\n  /* When changing width: also update `itemsPerRow` values in `src/components/Dashboard.js`. */\n  width: calc(20% - 15px - 15px);\n  height: 210px;\n  padding: 0;\n}\n.uppy-Dashboard--singleFile .uppy-Dashboard-Item {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 400px;\n  height: 100%;\n  border-bottom: 0;\n  position: relative;\n  padding: 15px;\n}\n\n.uppy-Dashboard-Item.is-ghost .uppy-Dashboard-Item-previewInnerWrap {\n  opacity: 0.2;\n}\n\n.uppy-Dashboard-Item.is-ghost .uppy-Dashboard-Item-name {\n  opacity: 0.7;\n}\n\n.uppy-Dashboard-Item.is-ghost .uppy-Dashboard-Item-preview::before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1005;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='35' height='39' viewBox='0 0 35 39'%3E%3Cpath d='M1.708 38.66c1.709 0 3.417-3.417 6.834-3.417 3.416 0 5.125 3.417 8.61 3.417 3.348 0 5.056-3.417 8.473-3.417 4.305 0 5.125 3.417 6.833 3.417.889 0 1.709-.889 1.709-1.709v-19.68C34.167-5.757 0-5.757 0 17.271v19.68c0 .82.888 1.709 1.708 1.709zm8.542-17.084a3.383 3.383 0 01-3.417-3.416 3.383 3.383 0 013.417-3.417 3.383 3.383 0 013.417 3.417 3.383 3.383 0 01-3.417 3.416zm13.667 0A3.383 3.383 0 0120.5 18.16a3.383 3.383 0 013.417-3.417 3.383 3.383 0 013.416 3.417 3.383 3.383 0 01-3.416 3.416z' fill='%2523000' fill-rule='nonzero'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: 50% 10px;\n  background-size: 25px;\n  opacity: 0.5;\n  content: \"\";\n}\n.uppy-size--md .uppy-Dashboard-Item.is-ghost .uppy-Dashboard-Item-preview::before {\n  background-position: 50% 50%;\n  background-size: 40px;\n}\n.uppy-Dashboard--singleFile .uppy-Dashboard-Item.is-ghost .uppy-Dashboard-Item-preview::before {\n  background-position: 50% 50%;\n  background-size: 30%;\n}\n\n.uppy-Dashboard-Item-preview {\n  position: relative;\n  flex-grow: 0;\n  flex-shrink: 0;\n  width: 50px;\n  height: 50px;\n}\n.uppy-size--md .uppy-Dashboard-Item-preview {\n  width: 100%;\n  height: 140px;\n}\n.uppy-size--lg .uppy-Dashboard-Item-preview {\n  height: 120px;\n}\n.uppy-size--xl .uppy-Dashboard-Item-preview {\n  height: 140px;\n}\n.uppy-Dashboard--singleFile .uppy-Dashboard-Item-preview {\n  width: 100%;\n  max-height: 75%;\n  flex-grow: 1;\n}\n.uppy-Dashboard--singleFile.uppy-size--md .uppy-Dashboard-Item-preview {\n  max-height: 100%;\n}\n\n[dir=\"ltr\"] .uppy-Dashboard-Item-fileInfoAndButtons{\n  padding-right: 8px;\n}\n\n[dir=\"rtl\"] .uppy-Dashboard-Item-fileInfoAndButtons{\n  padding-left: 8px;\n}\n\n[dir=\"ltr\"] .uppy-Dashboard-Item-fileInfoAndButtons{\n  padding-left: 12px;\n}\n\n[dir=\"rtl\"] .uppy-Dashboard-Item-fileInfoAndButtons{\n  padding-right: 12px;\n}\n\n.uppy-Dashboard-Item-fileInfoAndButtons {\n  display: flex;\n  flex-grow: 1;\n  align-items: center;\n  justify-content: space-between;\n}\n.uppy-size--md .uppy-Dashboard-Item-fileInfoAndButtons, .uppy-Dashboard--singleFile .uppy-Dashboard-Item-fileInfoAndButtons {\n  align-items: flex-start;\n  padding: 0;\n  padding-top: 9px;\n}\n.uppy-Dashboard--singleFile .uppy-Dashboard-Item-fileInfoAndButtons {\n  width: 100%;\n  flex-grow: 0;\n}\n\n.uppy-Dashboard-Item-fileInfo {\n  flex-grow: 1;\n  flex-shrink: 1;\n}\n\n.uppy-Dashboard-Item-actionWrapper {\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n\n.uppy-Dashboard-Item.is-inprogress .uppy-Dashboard-Item-previewInnerWrap::after,\n.uppy-Dashboard-Item.is-error .uppy-Dashboard-Item-previewInnerWrap::after {\n  display: block;\n}\n\n[dir=\"ltr\"] .uppy-Dashboard-Item-errorDetails{\n  left: 2px;\n}\n\n[dir=\"rtl\"] .uppy-Dashboard-Item-errorDetails{\n  right: 2px;\n}\n\n.uppy-Dashboard-Item-errorDetails {\n  position: relative;\n  top: 0;\n  flex-shrink: 0;\n  width: 13px;\n  height: 13px;\n  color: #fff;\n  font-weight: 600;\n  font-size: 10px;\n  line-height: 12px;\n  text-align: center;\n  background-color: #939393;\n  border-radius: 50%;\n  border: none;\n  cursor: help;\n  -webkit-appearance: none;\n          appearance: none;\n}\n\n.uppy-Dashboard-Item-errorDetails::after {\n  line-height: 1.3;\n  word-wrap: break-word;\n}\n\n.uppy-Dashboard-FileCard {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1005;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  background-color: #fff;\n  border-radius: 5px;\n  box-shadow: 0 0 10px 4px rgba(0, 0, 0, 0.1);\n}\n.uppy-Dashboard-FileCard .uppy-DashboardContent-bar {\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n.uppy-Dashboard-FileCard .uppy-Dashboard-FileCard-actions {\n  border-bottom-right-radius: 5px;\n  border-bottom-left-radius: 5px;\n}\n\n.uppy-Dashboard-FileCard-inner {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  flex-shrink: 1;\n  height: 100%;\n  min-height: 0;\n}\n\n.uppy-Dashboard-FileCard-preview {\n  position: relative;\n  display: flex;\n  flex-grow: 0;\n  flex-shrink: 1;\n  align-items: center;\n  justify-content: center;\n  height: 60%;\n  min-height: 0;\n  border-bottom: 1px solid #eaeaea;\n}\n[data-uppy-theme=dark] .uppy-Dashboard-FileCard-preview {\n  background-color: #333;\n  border-bottom: 0;\n}\n\n.uppy-Dashboard-FileCard-preview img.uppy-Dashboard-Item-previewImg {\n  flex: 0 0 auto;\n  max-width: 90%;\n  max-height: 90%;\n  object-fit: cover;\n  border-radius: 3px;\n  box-shadow: 0 3px 20px rgba(0, 0, 0, 0.15);\n}\n\n[dir=\"ltr\"] .uppy-Dashboard-FileCard-edit{\n  right: 10px;\n}\n\n[dir=\"rtl\"] .uppy-Dashboard-FileCard-edit{\n  left: 10px;\n}\n\n.uppy-Dashboard-FileCard-edit {\n  position: absolute;\n  top: 10px;\n  padding: 7px 15px;\n  color: #fff;\n  font-size: 13px;\n  background-color: rgba(0, 0, 0, 0.5);\n  border-radius: 50px;\n}\n.uppy-Dashboard-FileCard-edit:focus {\n  outline: none;\n}\n.uppy-Dashboard-FileCard-edit::-moz-focus-inner {\n  border: 0;\n}\n.uppy-Dashboard-FileCard-edit:focus {\n  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.5);\n}\n.uppy-Dashboard-FileCard-edit:hover {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n\n.uppy-Dashboard-FileCard-info {\n  flex-grow: 0;\n  flex-shrink: 0;\n  height: 40%;\n  padding: 30px 20px 20px 20px;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n[data-uppy-theme=dark] .uppy-Dashboard-FileCard-info {\n  background-color: #1f1f1f;\n}\n\n.uppy-Dashboard-FileCard-fieldset {\n  max-width: 640px;\n  margin: auto;\n  margin-bottom: 12px;\n  padding: 0;\n  font-size: 0;\n  border: 0;\n}\n\n.uppy-Dashboard-FileCard-label {\n  display: inline-block;\n  width: 22%;\n  color: #525252;\n  font-size: 12px;\n  vertical-align: middle;\n}\n.uppy-size--md .uppy-Dashboard-FileCard-label {\n  font-size: 14px;\n}\n[data-uppy-theme=dark] .uppy-Dashboard-FileCard-label {\n  color: #eaeaea;\n}\n\n.uppy-Dashboard-FileCard-input {\n  display: inline-block;\n  width: 78%;\n  vertical-align: middle;\n}\n\n.uppy-Dashboard-FileCard-actions {\n  display: flex;\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-items: center;\n  height: 55px;\n  padding: 0 15px;\n  background-color: #fafafa;\n  border-top: 1px solid #eaeaea;\n}\n.uppy-size--md .uppy-Dashboard-FileCard-actions {\n  height: 65px;\n}\n[data-uppy-theme=dark] .uppy-Dashboard-FileCard-actions {\n  background-color: #1f1f1f;\n  border-top: 1px solid #333;\n}\n\n[dir=\"ltr\"] .uppy-Dashboard-FileCard-actionsBtn{\n  margin-right: 10px;\n}\n\n[dir=\"rtl\"] .uppy-Dashboard-FileCard-actionsBtn{\n  margin-left: 10px;\n}\n\n.uppy-transition-slideDownUp-enter {\n  transform: translate3d(0, -105%, 0);\n  opacity: 0.01;\n  transition: transform 0.25s ease-in-out, opacity 0.25s ease-in-out;\n}\n\n.uppy-transition-slideDownUp-enter.uppy-transition-slideDownUp-enter-active {\n  transform: translate3d(0, 0, 0);\n  opacity: 1;\n}\n\n.uppy-transition-slideDownUp-leave {\n  transform: translate3d(0, 0, 0);\n  opacity: 1;\n  transition: transform 0.25s ease-in-out, opacity 0.25s ease-in-out;\n}\n\n.uppy-transition-slideDownUp-leave.uppy-transition-slideDownUp-leave-active {\n  transform: translate3d(0, -105%, 0);\n  opacity: 0.01;\n}\n\n@keyframes uppy-Dashboard-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes uppy-Dashboard-fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n@keyframes uppy-Dashboard-slideDownAndFadeIn {\n  from {\n    transform: translate3d(-50%, -70%, 0);\n    opacity: 0;\n  }\n  to {\n    transform: translate3d(-50%, -50%, 0);\n    opacity: 1;\n  }\n}\n@keyframes uppy-Dashboard-slideDownAndFadeIn--small {\n  from {\n    transform: translate3d(0, -20%, 0);\n    opacity: 0;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n    opacity: 1;\n  }\n}\n@keyframes uppy-Dashboard-slideUpFadeOut {\n  from {\n    transform: translate3d(-50%, -50%, 0);\n    opacity: 1;\n  }\n  to {\n    transform: translate3d(-50%, -70%, 0);\n    opacity: 0;\n  }\n}\n@keyframes uppy-Dashboard-slideUpFadeOut--small {\n  from {\n    transform: translate3d(0, 0, 0);\n    opacity: 1;\n  }\n  to {\n    transform: translate3d(0, -20%, 0);\n    opacity: 0;\n  }\n}\n.uppy-Dashboard--modal {\n  z-index: 1001;\n}\n\n.uppy-Dashboard--modal[aria-hidden=true] {\n  display: none;\n}\n\n.uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose > .uppy-Dashboard-inner {\n  animation: uppy-Dashboard-slideDownAndFadeIn--small 0.3s cubic-bezier(0, 0, 0.2, 1);\n}\n@media only screen and (min-width: 820px) {\n  .uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose > .uppy-Dashboard-inner {\n    animation: uppy-Dashboard-slideDownAndFadeIn 0.3s cubic-bezier(0, 0, 0.2, 1);\n  }\n}\n\n.uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose > .uppy-Dashboard-overlay {\n  animation: uppy-Dashboard-fadeIn 0.3s cubic-bezier(0, 0, 0.2, 1);\n}\n\n.uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose.uppy-Dashboard--isClosing > .uppy-Dashboard-inner {\n  animation: uppy-Dashboard-slideUpFadeOut--small 0.3s cubic-bezier(0, 0, 0.2, 1);\n}\n@media only screen and (min-width: 820px) {\n  .uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose.uppy-Dashboard--isClosing > .uppy-Dashboard-inner {\n    animation: uppy-Dashboard-slideUpFadeOut 0.3s cubic-bezier(0, 0, 0.2, 1);\n  }\n}\n\n.uppy-Dashboard--modal.uppy-Dashboard--animateOpenClose.uppy-Dashboard--isClosing > .uppy-Dashboard-overlay {\n  animation: uppy-Dashboard-fadeOut 0.3s cubic-bezier(0, 0, 0.2, 1);\n}\n\n.uppy-Dashboard-isFixed {\n  height: 100vh;\n  overflow: hidden;\n}\n\n.uppy-Dashboard--modal .uppy-Dashboard-overlay {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1001;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.uppy-Dashboard-inner {\n  position: relative;\n  max-width: 100%;\n  max-height: 100%;\n  background-color: #f4f4f4;\n  border: 1px solid #eaeaea;\n  border-radius: 5px;\n  outline: none;\n}\n.uppy-size--md .uppy-Dashboard-inner {\n  min-height: auto;\n}\n@media only screen and (min-width: 820px) {\n  .uppy-Dashboard-inner {\n    width: 650px;\n    height: 500px;\n  }\n}\n.uppy-Dashboard--modal .uppy-Dashboard-inner {\n  z-index: 1002;\n}\n[data-uppy-theme=dark] .uppy-Dashboard-inner {\n  background-color: #1f1f1f;\n}\n.uppy-Dashboard--isDisabled .uppy-Dashboard-inner {\n  cursor: not-allowed;\n}\n\n.uppy-Dashboard-innerWrap {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n  border-radius: 5px;\n  opacity: 0;\n}\n.uppy-Dashboard--isInnerWrapVisible .uppy-Dashboard-innerWrap {\n  opacity: 1;\n}\n.uppy-Dashboard--isDisabled .uppy-Dashboard-innerWrap {\n  opacity: 0.6;\n  filter: grayscale(100%);\n  -webkit-user-select: none;\n          user-select: none;\n  cursor: not-allowed;\n}\n\n.uppy-Dashboard--isDisabled .uppy-ProviderIconBg {\n  fill: #9f9f9f;\n}\n\n.uppy-Dashboard--isDisabled [disabled],\n.uppy-Dashboard--isDisabled [aria-disabled] {\n  pointer-events: none;\n  cursor: not-allowed;\n}\n\n.uppy-Dashboard--modal .uppy-Dashboard-inner {\n  position: fixed;\n  top: 35px;\n  right: 15px;\n  bottom: 15px;\n  left: 15px;\n  border: none;\n}\n@media only screen and (min-width: 820px) {\n  .uppy-Dashboard--modal .uppy-Dashboard-inner {\n    top: 50%;\n    right: auto;\n    left: 50%;\n    box-shadow: 0 5px 15px 4px rgba(0, 0, 0, 0.15);\n    transform: translate(-50%, -50%);\n  }\n}\n\n[dir=\"ltr\"] .uppy-Dashboard-close{\n  right: -2px;\n}\n\n[dir=\"rtl\"] .uppy-Dashboard-close{\n  left: -2px;\n}\n\n.uppy-Dashboard-close {\n  position: absolute;\n  top: -33px;\n  z-index: 1005;\n  display: block;\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 27px;\n  cursor: pointer;\n}\n.uppy-Dashboard-close:focus {\n  outline: none;\n}\n.uppy-Dashboard-close::-moz-focus-inner {\n  border: 0;\n}\n.uppy-Dashboard-close:focus {\n  color: #6eabf2;\n}\n@media only screen and (min-width: 820px) {\n  [dir=\"ltr\"] .uppy-Dashboard-close{\n    right: -35px;\n  }\n  [dir=\"rtl\"] .uppy-Dashboard-close{\n    left: -35px;\n  }\n  .uppy-Dashboard-close {\n    top: -10px;\n    font-size: 35px;\n  }\n}\n\n.uppy-Dashboard-serviceMsg {\n  position: relative;\n  top: -1px;\n  z-index: 1004;\n  padding: 12px 0;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 1.3;\n  background-color: #fffbf7;\n  border-top: 1px solid #edd4b9;\n  border-bottom: 1px solid #edd4b9;\n}\n.uppy-size--md .uppy-Dashboard-serviceMsg {\n  font-size: 14px;\n  line-height: 1.4;\n}\n[data-uppy-theme=dark] .uppy-Dashboard-serviceMsg {\n  color: #eaeaea;\n  background-color: #1f1f1f;\n  border-top: 1px solid #333;\n  border-bottom: 1px solid #333;\n}\n\n.uppy-Dashboard-serviceMsg-title {\n  display: block;\n  margin-bottom: 4px;\n  padding-left: 42px;\n  line-height: 1;\n}\n\n.uppy-Dashboard-serviceMsg-text {\n  padding: 0 15px;\n}\n\n.uppy-Dashboard-serviceMsg-actionBtn {\n  color: #1269cf;\n  font-weight: inherit;\n  font-size: inherit;\n  vertical-align: initial;\n}\n[data-uppy-theme=dark] .uppy-Dashboard-serviceMsg-actionBtn {\n  color: rgba(2, 186, 242, 0.9);\n}\n\n.uppy-Dashboard-serviceMsg-icon {\n  position: absolute;\n  top: 10px;\n  left: 15px;\n}\n\n.uppy-Dashboard-AddFiles {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  text-align: center;\n}\n[data-uppy-drag-drop-supported=true] .uppy-Dashboard-AddFiles {\n  height: calc(100% - 14px);\n  margin: 7px;\n  border: 1px dashed #dfdfdf;\n  border-radius: 3px;\n}\n.uppy-Dashboard-AddFilesPanel .uppy-Dashboard-AddFiles {\n  height: calc(100% - 14px - 40px);\n  border: none;\n}\n.uppy-Dashboard--modal .uppy-Dashboard-AddFiles {\n  border-color: #cfcfcf;\n}\n[data-uppy-theme=dark] .uppy-Dashboard-AddFiles {\n  border-color: #757575;\n}\n\n.uppy-Dashboard-AddFiles-info {\n  display: none;\n  margin-top: auto;\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n.uppy-size--height-md .uppy-Dashboard-AddFiles-info {\n  display: block;\n}\n.uppy-size--md .uppy-Dashboard-AddFiles-info {\n  position: absolute;\n  right: 0;\n  bottom: 25px;\n  left: 0;\n  padding-top: 30px;\n  padding-bottom: 0;\n}\n[data-uppy-num-acquirers=\"0\"] .uppy-Dashboard-AddFiles-info {\n  margin-top: 0;\n}\n\n.uppy-Dashboard-browse {\n  color: #1269cf;\n  cursor: pointer;\n}\n.uppy-Dashboard-browse:focus {\n  outline: none;\n}\n.uppy-Dashboard-browse::-moz-focus-inner {\n  border: 0;\n}\n.uppy-Dashboard-browse:hover, .uppy-Dashboard-browse:focus {\n  border-bottom: 1px solid #1269cf;\n}\n[data-uppy-theme=dark] .uppy-Dashboard-browse {\n  color: rgba(2, 186, 242, 0.9);\n}\n[data-uppy-theme=dark] .uppy-Dashboard-browse:hover, [data-uppy-theme=dark] .uppy-Dashboard-browse:focus {\n  border-bottom: 1px solid #02baf2;\n}\n\n.uppy-Dashboard-browseBtn {\n  display: block;\n  width: 100%;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  font-size: 14px;\n}\n.uppy-size--md .uppy-Dashboard-browseBtn {\n  width: auto;\n  margin: auto;\n  margin-top: 15px;\n  margin-bottom: 15px;\n  padding: 13px 44px;\n  font-size: 15px;\n}\n\n.uppy-Dashboard-AddFiles-list {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  width: 100%;\n  margin-top: 2px;\n  padding: 2px 0;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.uppy-size--md .uppy-Dashboard-AddFiles-list {\n  flex: none;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  max-width: 600px;\n  margin-top: 15px;\n  padding-top: 0;\n  overflow-y: visible;\n}\n\n.uppy-DashboardTab {\n  width: 100%;\n  text-align: center;\n  border-bottom: 1px solid #eaeaea;\n}\n[data-uppy-theme=dark] .uppy-DashboardTab {\n  border-bottom: 1px solid #333;\n}\n.uppy-size--md .uppy-DashboardTab {\n  display: inline-block;\n  width: initial;\n  margin-bottom: 10px;\n  border-bottom: none;\n}\n\n.uppy-DashboardTab-btn {\n  flex-direction: row;\n  align-items: center;\n  justify-content: left;\n  width: 100%;\n  height: 100%;\n  padding: 12px 15px;\n  color: #525252;\n  background-color: transparent;\n  cursor: pointer;\n  -webkit-appearance: none;\n  appearance: none;\n}\n.uppy-DashboardTab-btn:focus {\n  outline: none;\n}\n.uppy-DashboardTab-btn::-moz-focus-inner {\n  border: 0;\n}\n[dir=\"ltr\"] .uppy-size--md .uppy-DashboardTab-btn{\n  margin-right: 1px;\n}\n[dir=\"rtl\"] .uppy-size--md .uppy-DashboardTab-btn{\n  margin-left: 1px;\n}\n.uppy-size--md .uppy-DashboardTab-btn {\n  flex-direction: column;\n  width: 86px;\n  padding: 10px 3px;\n  border-radius: 5px;\n}\n[data-uppy-theme=dark] .uppy-DashboardTab-btn {\n  color: #eaeaea;\n}\n\n.uppy-DashboardTab-btn::-moz-focus-inner {\n  border: 0;\n}\n\n.uppy-DashboardTab-btn:hover {\n  background-color: #e9ecef;\n}\n[data-uppy-theme=dark] .uppy-DashboardTab-btn:hover {\n  background-color: #333;\n}\n\n.uppy-DashboardTab-btn:active,\n.uppy-DashboardTab-btn:focus {\n  background-color: #dfe6f1;\n}\n[data-uppy-theme=dark] .uppy-DashboardTab-btn:active,\n[data-uppy-theme=dark] .uppy-DashboardTab-btn:focus {\n  background-color: #525252;\n}\n\n.uppy-DashboardTab-btn svg {\n  display: inline-block;\n  max-width: 100%;\n  max-height: 100%;\n  overflow: hidden;\n  vertical-align: text-top;\n  transition: transform ease-in-out 0.15s;\n}\n\n[dir=\"ltr\"] .uppy-DashboardTab-inner{\n  margin-right: 10px;\n}\n\n[dir=\"rtl\"] .uppy-DashboardTab-inner{\n  margin-left: 10px;\n}\n\n.uppy-DashboardTab-inner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background-color: #fff;\n  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.1), 0 2px 3px 0 rgba(0, 0, 0, 0.02);\n}\n[dir=\"ltr\"] .uppy-size--md .uppy-DashboardTab-inner{\n  margin-right: 0;\n}\n[dir=\"rtl\"] .uppy-size--md .uppy-DashboardTab-inner{\n  margin-left: 0;\n}\n[data-uppy-theme=dark] .uppy-DashboardTab-inner {\n  background-color: #323232;\n  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2), 0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 2px 3px 0 rgba(0, 0, 0, 0.08);\n}\n\n.uppy-DashboardTab-name {\n  font-weight: 400;\n  font-size: 14px;\n}\n.uppy-size--md .uppy-DashboardTab-name {\n  margin-top: 8px;\n  margin-bottom: 0;\n  font-size: 12px;\n  line-height: 15px;\n}\n\n.uppy-DashboardTab-iconMyDevice {\n  color: #1269cf;\n}\n[data-uppy-theme=dark] .uppy-DashboardTab-iconMyDevice {\n  color: #02baf2;\n}\n\n.uppy-DashboardTab-iconBox {\n  color: #0061d5;\n}\n[data-uppy-theme=dark] .uppy-DashboardTab-iconBox {\n  color: #eaeaea;\n}\n\n.uppy-DashboardTab-iconDropbox {\n  color: #0061fe;\n}\n[data-uppy-theme=dark] .uppy-DashboardTab-iconDropbox {\n  color: #eaeaea;\n}\n\n.uppy-DashboardTab-iconUnsplash {\n  color: #111;\n}\n[data-uppy-theme=dark] .uppy-DashboardTab-iconUnsplash {\n  color: #eaeaea;\n}\n\n.uppy-DashboardTab-iconWebdav {\n  color: #111;\n}\n[data-uppy-theme=dark] .uppy-DashboardTab-iconWebdav {\n  color: #eaeaea;\n}\n\n.uppy-DashboardTab-iconScreenRec {\n  color: #2c3e50;\n}\n[data-uppy-theme=dark] .uppy-DashboardTab-iconScreenRec {\n  color: #eaeaea;\n}\n\n.uppy-DashboardTab-iconAudio {\n  color: #8030a3;\n}\n[data-uppy-theme=dark] .uppy-DashboardTab-iconAudio {\n  color: #bf6ee3;\n}\n\n.uppy-Dashboard-input {\n  position: absolute;\n  z-index: -1;\n  width: 0.1px;\n  height: 0.1px;\n  overflow: hidden;\n  opacity: 0;\n}\n\n.uppy-DashboardContent-bar {\n  position: relative;\n  z-index: 1004;\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 40px;\n  padding: 0 10px;\n  background-color: #fafafa;\n  border-bottom: 1px solid #eaeaea;\n}\n.uppy-size--md .uppy-DashboardContent-bar {\n  height: 50px;\n  padding: 0 15px;\n}\n[data-uppy-theme=dark] .uppy-DashboardContent-bar {\n  background-color: #1f1f1f;\n  border-bottom: 1px solid #333;\n}\n\n.uppy-DashboardContent-title {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  width: 100%;\n  max-width: 170px;\n  margin: auto;\n  overflow-x: hidden;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 40px;\n  white-space: nowrap;\n  text-align: center;\n  text-overflow: ellipsis;\n}\n.uppy-size--md .uppy-DashboardContent-title {\n  max-width: 300px;\n  font-size: 14px;\n  line-height: 50px;\n}\n[data-uppy-theme=dark] .uppy-DashboardContent-title {\n  color: #eaeaea;\n}\n\n[dir=\"ltr\"] .uppy-DashboardContent-back,[dir=\"ltr\"] \n.uppy-DashboardContent-save{\n  margin-left: -6px;\n}\n\n[dir=\"rtl\"] .uppy-DashboardContent-back,[dir=\"rtl\"] \n.uppy-DashboardContent-save{\n  margin-right: -6px;\n}\n\n.uppy-DashboardContent-back,\n.uppy-DashboardContent-save {\n  margin: 0;\n  padding: 0;\n  color: inherit;\n  font-size: inherit;\n  font-family: inherit;\n  line-height: 1;\n  background: none;\n  border: 0;\n  -webkit-appearance: none;\n  padding: 7px 6px;\n  color: #1269cf;\n  font-weight: 400;\n  font-size: 12px;\n  border-radius: 3px;\n  cursor: pointer;\n}\n.uppy-DashboardContent-back:focus,\n.uppy-DashboardContent-save:focus {\n  outline: none;\n}\n.uppy-DashboardContent-back::-moz-focus-inner,\n.uppy-DashboardContent-save::-moz-focus-inner {\n  border: 0;\n}\n.uppy-DashboardContent-back:hover,\n.uppy-DashboardContent-save:hover {\n  color: #0e51a0;\n}\n.uppy-DashboardContent-back:focus,\n.uppy-DashboardContent-save:focus {\n  background-color: #dfe6f1;\n}\n[data-uppy-theme=dark] .uppy-DashboardContent-back:focus,\n[data-uppy-theme=dark] .uppy-DashboardContent-save:focus {\n  background-color: #333;\n}\n.uppy-size--md .uppy-DashboardContent-back,\n.uppy-size--md .uppy-DashboardContent-save {\n  font-size: 14px;\n}\n[data-uppy-theme=dark] .uppy-DashboardContent-back,\n[data-uppy-theme=dark] .uppy-DashboardContent-save {\n  color: #02baf2;\n}\n\n[dir=\"ltr\"] .uppy-DashboardContent-addMore{\n  margin-right: -5px;\n}\n\n[dir=\"rtl\"] .uppy-DashboardContent-addMore{\n  margin-left: -5px;\n}\n\n.uppy-DashboardContent-addMore {\n  margin: 0;\n  padding: 0;\n  color: inherit;\n  font-size: inherit;\n  font-family: inherit;\n  line-height: 1;\n  background: none;\n  border: 0;\n  -webkit-appearance: none;\n  width: 29px;\n  height: 29px;\n  padding: 7px 8px;\n  color: #1269cf;\n  font-weight: 500;\n  border-radius: 3px;\n  cursor: pointer;\n}\n.uppy-DashboardContent-addMore:focus {\n  outline: none;\n}\n.uppy-DashboardContent-addMore::-moz-focus-inner {\n  border: 0;\n}\n.uppy-DashboardContent-addMore:hover {\n  color: #0e51a0;\n}\n.uppy-DashboardContent-addMore:focus {\n  background-color: #dfe6f1;\n}\n[data-uppy-theme=dark] .uppy-DashboardContent-addMore:focus {\n  background-color: #333;\n}\n[dir=\"ltr\"] .uppy-size--md .uppy-DashboardContent-addMore{\n  margin-right: -8px;\n}\n[dir=\"rtl\"] .uppy-size--md .uppy-DashboardContent-addMore{\n  margin-left: -8px;\n}\n.uppy-size--md .uppy-DashboardContent-addMore {\n  width: auto;\n  height: auto;\n  font-size: 14px;\n}\n[data-uppy-theme=dark] .uppy-DashboardContent-addMore {\n  color: #02baf2;\n}\n\n[dir=\"ltr\"] .uppy-DashboardContent-addMore svg{\n  margin-right: 4px;\n}\n\n[dir=\"rtl\"] .uppy-DashboardContent-addMore svg{\n  margin-left: 4px;\n}\n\n.uppy-DashboardContent-addMore svg {\n  vertical-align: baseline;\n}\n.uppy-size--md .uppy-DashboardContent-addMore svg {\n  width: 11px;\n  height: 11px;\n}\n\n.uppy-DashboardContent-addMoreCaption {\n  display: none;\n}\n.uppy-size--md .uppy-DashboardContent-addMoreCaption {\n  display: inline;\n}\n\n.uppy-DashboardContent-panel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1005;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow: hidden;\n  background-color: whitesmoke;\n  border-radius: 5px;\n}\n\n.uppy-Dashboard-AddFilesPanel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1005;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: #fafafa;\n  background: linear-gradient(0deg, #fafafa 35%, rgba(250, 250, 250, 0.85) 100%);\n  border-radius: 5px;\n  box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.15);\n}\n[data-uppy-theme=dark] .uppy-Dashboard-AddFilesPanel {\n  background-color: #333;\n  background-image: linear-gradient(0deg, #1f1f1f 35%, rgba(31, 31, 31, 0.85) 100%);\n}\n\n.uppy-Dashboard--isAddFilesPanelVisible .uppy-Dashboard-files {\n  filter: blur(2px);\n}\n\n.uppy-Dashboard-progress {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 12%;\n}\n\n.uppy-Dashboard-progressBarContainer.is-active {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1004;\n  width: 100%;\n  height: 100%;\n}\n\n.uppy-Dashboard-filesContainer {\n  position: relative;\n  flex: 1;\n  margin: 0;\n  overflow-y: hidden;\n}\n.uppy-Dashboard-filesContainer::after {\n  display: table;\n  clear: both;\n  content: \"\";\n}\n\n.uppy-Dashboard-files {\n  flex: 1;\n  margin: 0;\n  padding: 0 0 10px 0;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.uppy-size--md .uppy-Dashboard-files {\n  padding-top: 10px;\n}\n\n.uppy-Dashboard--singleFile .uppy-Dashboard-filesInner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.uppy-Dashboard-dropFilesHereHint {\n  position: absolute;\n  top: 7px;\n  right: 7px;\n  bottom: 7px;\n  left: 7px;\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 90px;\n  color: #757575;\n  font-size: 16px;\n  text-align: center;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='48' height='48' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M24 1v1C11.85 2 2 11.85 2 24s9.85 22 22 22 22-9.85 22-22S36.15 2 24 2V1zm0 0V0c13.254 0 24 10.746 24 24S37.254 48 24 48 0 37.254 0 24 10.746 0 24 0v1zm7.707 19.293a.999.999 0 1 1-1.414 1.414L25 16.414V34a1 1 0 1 1-2 0V16.414l-5.293 5.293a.999.999 0 1 1-1.414-1.414l7-7a.999.999 0 0 1 1.414 0l7 7z' fill='%231269CF' fill-rule='nonzero'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  border: 1px dashed #1269cf;\n  border-radius: 3px;\n  visibility: hidden;\n}\n[data-uppy-theme=dark] .uppy-Dashboard-dropFilesHereHint {\n  color: #bbb;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='48' height='48' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M24 1v1C11.85 2 2 11.85 2 24s9.85 22 22 22 22-9.85 22-22S36.15 2 24 2V1zm0 0V0c13.254 0 24 10.746 24 24S37.254 48 24 48 0 37.254 0 24 10.746 0 24 0v1zm7.707 19.293a.999.999 0 1 1-1.414 1.414L25 16.414V34a1 1 0 1 1-2 0V16.414l-5.293 5.293a.999.999 0 1 1-1.414-1.414l7-7a.999.999 0 0 1 1.414 0l7 7z' fill='%2302BAF2' fill-rule='nonzero'/%3E%3C/svg%3E\");\n  border-color: #02baf2;\n}\n\n.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-Dashboard-dropFilesHereHint {\n  visibility: visible;\n  pointer-events: none;\n}\n.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-DashboardContent-bar,\n.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-Dashboard-files,\n.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-Dashboard-progressindicators,\n.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-Dashboard-serviceMsg {\n  opacity: 0.15;\n}\n.uppy-Dashboard.uppy-Dashboard--isDraggingOver .uppy-Dashboard-AddFiles {\n  opacity: 0.03;\n}\n\n.uppy-Dashboard-AddFiles-title {\n  width: 100%;\n  margin-top: 15px;\n  margin-bottom: 5px;\n  padding: 0 15px;\n  color: #000;\n  font-weight: 500;\n  font-size: 17px;\n  line-height: 1.35;\n  text-align: inline-start;\n}\n.uppy-size--md .uppy-Dashboard-AddFiles-title {\n  max-width: 480px;\n  padding: 0 35px;\n  margin-top: 5px;\n  font-weight: 400;\n  font-size: 21px;\n  text-align: center;\n}\n[data-uppy-num-acquirers=\"0\"] .uppy-Dashboard-AddFiles-title {\n  text-align: center;\n}\n[data-uppy-theme=dark] .uppy-Dashboard-AddFiles-title {\n  color: #eaeaea;\n}\n.uppy-Dashboard-AddFiles-title button {\n  font-weight: 500;\n}\n.uppy-size--md .uppy-Dashboard-AddFiles-title button {\n  font-weight: 400;\n}\n\n.uppy-Dashboard-note {\n  max-width: 350px;\n  margin: auto;\n  padding: 0 15px;\n  color: #757575;\n  font-size: 14px;\n  line-height: 1.25;\n  text-align: center;\n}\n.uppy-size--md .uppy-Dashboard-note {\n  max-width: 600px;\n  line-height: 1.35;\n}\n[data-uppy-theme=dark] .uppy-Dashboard-note {\n  color: #cfcfcf;\n}\n\na.uppy-Dashboard-poweredBy {\n  display: inline-block;\n  margin-top: 8px;\n  color: #939393;\n  font-size: 11px;\n  text-align: center;\n  text-decoration: none;\n}\n\n.uppy-Dashboard-poweredByIcon {\n  position: relative;\n  top: 1px;\n  margin-right: 1px;\n  margin-left: 1px;\n  vertical-align: text-top;\n  opacity: 0.9;\n  fill: none;\n  stroke: #939393;\n}\n\n.uppy-Dashboard-Item-previewIcon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 100;\n  width: 25px;\n  height: 25px;\n  transform: translate(-50%, -50%);\n}\n.uppy-size--md .uppy-Dashboard-Item-previewIcon {\n  width: 38px;\n  height: 38px;\n}\n.uppy-Dashboard-Item-previewIcon svg {\n  width: 100%;\n  height: 100%;\n}\n.uppy-Dashboard--singleFile .uppy-Dashboard-Item-previewIcon {\n  width: 100%;\n  height: 100%;\n  max-width: 60%;\n  max-height: 60%;\n}\n\n.uppy-Dashboard-Item-previewIconWrap {\n  position: relative;\n  height: 76px;\n  max-height: 75%;\n}\n.uppy-Dashboard--singleFile .uppy-Dashboard-Item-previewIconWrap {\n  width: 100%;\n  height: 100%;\n}\n\n.uppy-Dashboard-Item-previewIconBg {\n  width: 100%;\n  height: 100%;\n  filter: drop-shadow(rgba(0, 0, 0, 0.1) 0 1px 1px);\n}\n\n.uppy-Dashboard-upload {\n  position: relative;\n  width: 50px;\n  height: 50px;\n}\n.uppy-size--md .uppy-Dashboard-upload {\n  width: 60px;\n  height: 60px;\n}\n\n.uppy-Dashboard-upload .uppy-c-icon {\n  position: relative;\n  top: 1px;\n  width: 50%;\n}\n\n[dir=\"ltr\"] .uppy-Dashboard-uploadCount{\n  right: -12px;\n}\n\n[dir=\"rtl\"] .uppy-Dashboard-uploadCount{\n  left: -12px;\n}\n\n.uppy-Dashboard-uploadCount {\n  position: absolute;\n  top: -12px;\n  width: 16px;\n  height: 16px;\n  color: #fff;\n  font-size: 8px;\n  line-height: 16px;\n  background-color: #1bb240;\n  border-radius: 50%;\n}\n.uppy-size--md .uppy-Dashboard-uploadCount {\n  width: 18px;\n  height: 18px;\n  font-size: 9px;\n  line-height: 18px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
